import React, {
  useEffect,
  useMemo,
  useState,
  useRef,
  useCallback,
} from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Card,
  FormControlLabel,
  FormGroup,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import COCVmsDatePicker from "../../../VMS/VMSComponent/COCVmsDatePicker";
import POPVmsDatePicker from "../../../VMS/VMSComponent/POPVmsDatePicker";
import SPCSmartTagList from "../../Smartagcomponent/SPCSmartTagList";
import GraphComponent from "../../Smartagcomponent/GraphComponent";
import "./MachineAnalytics.css";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSmartTagReportData } from "../Slice";
import { images } from "../../../../config";
import dayjs from "dayjs";
import { ToastContainer, toast } from "react-toastify";
import {
  getDeviceByDashboard,
  getPiechartCOC,
  getTagList,
  tagInteractionData,
  getAnalyticsIChartDetail,
  getAnalyticsMRChartDetail,
  getSPCReportTableDetails,
} from "../../services";
import TagListComponent from "../../../VMS/VmsCompanyDashboard/VmsMachine/Reports/TagListComponent/TagListComponent";
import {
  getReportAPIAnalyticsData,
  getReportAPIComp,
} from "../../../VMS/VmsCompanyDashboard/VmsMachine/Reports/getReportAPIComp";
import { getDeviceUnits } from "../../../VMS/VmsCompanyDashboard/VmsMachine/Reports/service";
import {
  getStorePreviousSelectedData,
  storeSelectedData,
} from "../../../VMS/VmsCompanyDashboard/VmsMachine/service";
import { userFootFallTracking } from "../../../ProcessDashboard/service";
import SPCGraphComponent from "../../Smartagcomponent/SPCGraphComponent";

const SPCMachineAnalytics = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [rangeModal, setRangeModal] = useState(false);
  const [rangeModalPOP, setRangeModalPOP] = useState(false);
  const [Machines, setMachines] = useState([]);
  const [unit, setUnit] = useState([]);
  const [tagListData, setTagListData] = useState([]);
  const [tagListData1, setTagListData1] = useState([]);
  const [cocGraphdata, setCocGraphData] = useState([]);
  // SPC Chart data for I Chart (different format from cocGraphdata)
  const [spcChartData, setSpcChartData] = useState([]);
  // Analytics I Chart and MR Chart data
  const [analyticsIChartData, setAnalyticsIChartData] = useState([]);
  const [analyticsMRChartData, setAnalyticsMRChartData] = useState([]);
  // Control limits for I Chart
  const [analyticsIChartUcl, setAnalyticsIChartUcl] = useState(null);
  const [analyticsIChartCl, setAnalyticsIChartCl] = useState(null);
  const [analyticsIChartLcl, setAnalyticsIChartLcl] = useState(null);
  // Control limits for MR Chart
  const [analyticsMRChartUcl, setAnalyticsMRChartUcl] = useState(null);
  const [analyticsMRChartCl, setAnalyticsMRChartCl] = useState(null);
  const [analyticsMRChartLcl, setAnalyticsMRChartLcl] = useState(null);
  // Tag name for analytics charts
  const [analyticsTagName, setAnalyticsTagName] = useState("");
  // Tag color for analytics charts
  const [analyticsTagColor, setAnalyticsTagColor] = useState(null);
  // Polling refs for analytics charts
  const analyticsIChartIntervalRef = useRef(null);
  const analyticsMRChartIntervalRef = useRef(null);
  const analyticsIChartStartDateRef = useRef(null);
  // Ref for Reports chart (for export functionality)
  const reportsChartRef = useRef(null);
  // Refs for Analytics charts (for export functionality)
  const analyticsIChartRef = useRef(null);
  const analyticsMRChartRef = useRef(null);
  const analyticsMRChartStartDateRef = useRef(null);
  const analyticsIChartInitialStartDateRef = useRef(null); // Store the first API call's start date
  const analyticsMRChartInitialStartDateRef = useRef(null); // Store the first API call's start date
  const analyticsCurrentTagIdRef = useRef(null);
  // Refs to track previous intervals for change detection
  // Function to get chart base64 for export (Reports mode only)
  const getChartBase64 = async () => {
    if (activeSPCClass !== "reports" || !reportsChartRef.current) {
      throw new Error("Chart is not available");
    }
    // The ref.current is the ref object from SPCGraphComponent, need to access .current to get the component
    const chartComponentRef = reportsChartRef.current;
    if (!chartComponentRef || !chartComponentRef.current) {
      throw new Error("Chart component is not available");
    }
    const chartComponent = chartComponentRef.current;
    if (!chartComponent || !chartComponent.exportChartAsBase64) {
      throw new Error("Chart export method is not available");
    }
    return await chartComponent.exportChartAsBase64();
  };
  // Function to get Analytics charts base64 for export (Analytics mode only)
  const getAnalyticsChartsBase64 = async () => {
    if (activeSPCClass !== "analytics") {
      throw new Error("Analytics charts are only available in analytics mode");
    }
    // Get I Chart base64
    let base64ImageIChart = "";
    if (!analyticsIChartRef.current) {
      throw new Error("I Chart is not available for export");
    }
    const iChartComponentRef = analyticsIChartRef.current;
    if (!iChartComponentRef || !iChartComponentRef.current) {
      throw new Error("I Chart component is not available");
    }
    const iChartComponent = iChartComponentRef.current;
    if (!iChartComponent || !iChartComponent.exportChartAsBase64) {
      throw new Error("I Chart export method is not available");
    }
    base64ImageIChart = await iChartComponent.exportChartAsBase64();

    // Get MR Chart base64
    let base64ImageMRChart = "";
    if (!analyticsMRChartRef.current) {
      throw new Error("MR Chart is not available for export");
    }
    const mrChartComponentRef = analyticsMRChartRef.current;
    if (!mrChartComponentRef || !mrChartComponentRef.current) {
      throw new Error("MR Chart component is not available");
    }
    const mrChartComponent = mrChartComponentRef.current;
    if (!mrChartComponent || !mrChartComponent.exportChartAsBase64) {
      throw new Error("MR Chart export method is not available");
    }
    base64ImageMRChart = await mrChartComponent.exportChartAsBase64();

    return {
      base64_image_ichart: base64ImageIChart,
      base64_image_mrchart: base64ImageMRChart,
    };
  };
  const prevIChartIntervalRef = useRef(null);
  const prevMRChartIntervalRef = useRef(null);
  // Refs to track if auto-selection from Redux has been completed for each tab
  const hasAutoSelectedFromReduxAnalyticsRef = useRef(false);
  const hasAutoSelectedFromReduxReportsRef = useRef(false);
  // Refs to track previous Redux data to detect changes
  const prevSPCTopBarTagDataRef = useRef(null);
  const prevSPCtagClickebleDataRef = useRef(null);
  const [averageCOCLineArray, setAverageCOCLineArray] = useState([]);
  const [popBarGraphData1, setPopBarGraphData1] = useState([]);
  const [popBarGraphData2, setPopBarGraphData2] = useState([]);
  const [averagePOPLineArray, setAveragePOPLineArray] = useState([]);
  const [isShimmerdevicelistCOC, setisShimmerdevicelistCOC] = useState(false);
  const [isShimmerdevicelistPOP, setisShimmerdevicelistPOP] = useState(false);
  const [isShimmerUnitlistCOC, setisShimmerUnitlistCOC] = useState(false);
  const [isShimmerMachineslistCOC, setisShimmerMachineslistCOC] =
    useState(false);
  const [isShimmerUnitlistPOP, setisShimmerUnitlistPOP] = useState(false);
  const [isShimmerMachineslistPOP, setisShimmerMachineslistPOP] =
    useState(false);
  const [unitsData, setUnitsData] = useState([]);
  const [LineCOCIntervalTime, setLineCOCIntervalTime] = useState("1");
  const [LinePOPIntervalTime, setLinePOPIntervalTime] = useState("1");
  // Separate intervals for I Chart and MR Chart
  const [analyticsIChartInterval, setAnalyticsIChartInterval] = useState("5");
  const [analyticsMRChartInterval, setAnalyticsMRChartInterval] = useState("5");
  const [rangeCOC, setRangeCOC] = useState("");
  const [rangePOP, setRangePOP] = useState("");
  // Selected chart type for reports tab dropdown
  const [selectedChartType, setSelectedChartType] = useState("I Chart");
  const [selectedPreviousData, setSelectedPreviousData] = useState([]);
  const [smartTagCOCTime, setSmartTagCOCTime] = useState(false);
  const [smartTagPOPTime, setSmartTagPOPTime] = useState(false);
  const [disableOtherUnits, setDisableOtherUnits] = useState(false);
  const [disableOtherUnitsPOP, setDisableOtherUnitsPOP] = useState(false);
  const [piechartData, setPiechartData] = useState([]);
  const [pieChartSum, setPieChartSum] = useState("");
  const [piechartDataPOP, setPiechartDataPOP] = useState([]);
  const [piechartDataPOP1, setPiechartDataPOP1] = useState([]);

  const {
    activeSPCClass,
    COCIntervalTime,
    POPIntervalTimePop,
    SPCTopBarTagData,
    SPCtagClickebleData,
  } = useSelector((state) => state.smartTagReportSlice);

  console.log("SPCTopBarTagData", SPCTopBarTagData);

  // shortcut data

  const [selectDeviceData, setSelectDeviceData] = useState([]);
  const [selectUnitData, setSelectUnitData] = useState([]);
  const [selectTagData, setSelectTagData] = useState([]);

  const [selectPOPDeviceData, setSelectPOPDeviceData] = useState([]);
  const [selectPOPUnitData, setSelectPOPUnitData] = useState([]);
  const [selectPOPTagData, setSelectPOPTagData] = useState([]);
  const [isShimmerCOC, setShimmerCOC] = useState(false);
  const [isShimmerPOP, setShimmerPOP] = useState(false);
  const [rangeCOCValue, setRangeCOCValue] = useState("Set Range");
  const [rangePOPValue, setRangePOPValue] = useState("Set Range");
  const [smartTagCOCSelectMachine, setSmartTagCOCSelectMachine] = useState([]);
  const [smartTagCOCSelectUnit, setSmartTagCOCSelectUnit] = useState([]);
  const [smartTagCOCSelectTag, setSmartTagCOCSelectTag] = useState([]);
  const [smartTagPOPSelectMachine, setSmartTagPOPSelectMachine] = useState([]);
  const [smartTagPOPSelectUnit, setSmartTagPOPSelectUnit] = useState([]);
  const [smartTagPOPSelectTag, setSmartTagPOPSelectTag] = useState([]);
  const [smartTagCOCSwitch, setSmartTagCOCSwitch] = useState(false);
  const [smartTagPOPSwitch, setSmartTagPOPSwitch] = useState(false);
  const [aggCOC, setAggCOC] = useState(15);
  const [aggPOP, setAggPOP] = useState(15);
  const [selectedReportChartInterval, setSelectedReportChartInterval] =
    useState("5");

  const [smartTagCOCStartDate, setSmartTagCOCStartDate] = useState(
    smartTagCOCSwitch ? dayjs().subtract(24, "hour") : null
  );
  const [smartTagCOCEndDate, setSmartTagCOCEndDate] = useState(
    smartTagCOCSwitch ? dayjs() : null
  );
  const [smartTagPOPStartDate, setSmartTagPOPStartDate] = useState(
    smartTagPOPSwitch ? dayjs().subtract(24, "hour") : null
  );
  const [smartTagPOPEndDate, setSmartTagPOPEndDate] = useState(
    smartTagPOPSwitch ? dayjs() : null
  );
  const [smartTagPOP1StartDate, setSmartTagPOP1StartDate] = useState(
    smartTagPOPSwitch ? dayjs().subtract(24, "hour") : null
  );
  const [smartTagPOP1EndDate, setSmartTagPOP1EndDate] = useState(
    smartTagPOPSwitch ? dayjs() : null
  );

  useEffect(() => {
    if (params.deviceId) {
      // Use SPCtagClickebleData if available, otherwise fallback to SPCtagClickebleData
      const dataSource = SPCtagClickebleData?.length
        ? SPCtagClickebleData
        : SPCtagClickebleData;

      setSelectDeviceData([
        {
          machineId: dataSource?.length
            ? dataSource.find((f) => f.plantId == params.plantid)?.["machineId"]
            : "",
          plantId: params.plantid,
        },
      ]);
      setSelectUnitData([
        {
          tagUnit: dataSource?.length
            ? dataSource.find((f) => f.plantId == params.plantid)?.["tagUnit"]
            : "",
          machineId: dataSource?.length
            ? dataSource.find((f) => f.plantId == params.plantid)?.["machineId"]
            : "",
          plantId: params.plantid,
        },
      ]);
      setSelectTagData([
        {
          tagId: dataSource?.length
            ? dataSource.find((f) => f.plantId == params.plantid)?.["tagId"]
            : "",
          tagName: dataSource?.length
            ? dataSource.find((f) => f.plantId == params.plantid)?.["tagName"]
            : "",
          tagUnit: dataSource?.length
            ? dataSource.find((f) => f.plantId == params.plantid)?.["tagUnit"]
            : "",
          machineId: dataSource?.length
            ? dataSource.find((f) => f.plantId == params.plantid)?.["machineId"]
            : "",
          plantId: params.plantid,
        },
      ]);
    }
  }, [
    SPCtagClickebleData,
    SPCtagClickebleData,
    params.deviceId,
    params.plantid,
  ]);

  useEffect(() => {
    if (params.deviceId) {
      // Use SPCtagClickebleData if available, otherwise fallback to SPCtagClickebleData
      const dataSource = SPCtagClickebleData?.length
        ? SPCtagClickebleData
        : SPCtagClickebleData;

      setSelectPOPDeviceData([
        {
          machineId: dataSource?.length
            ? dataSource.find((f) => f.plantId == params.plantid)?.["machineId"]
            : "",
          plantId: params.plantid,
        },
      ]);
      setSelectPOPUnitData([
        {
          tagUnit: dataSource?.length
            ? dataSource.find((f) => f.plantId == params.plantid)?.["tagUnit"]
            : "",
          machineId: dataSource?.length
            ? dataSource.find((f) => f.plantId == params.plantid)?.["machineId"]
            : "",
          plantId: params.plantid,
        },
      ]);
      setSelectPOPTagData([
        {
          tagId: dataSource?.length
            ? dataSource.find((f) => f.plantId == params.plantid)?.["tagId"]
            : "",
          tagName: dataSource?.length
            ? dataSource.find((f) => f.plantId == params.plantid)?.["tagName"]
            : "",
          tagUnit: dataSource?.length
            ? dataSource.find((f) => f.plantId == params.plantid)?.["tagUnit"]
            : "",
          machineId: dataSource?.length
            ? dataSource.find((f) => f.plantId == params.plantid)?.["machineId"]
            : "",
          plantId: params.plantid,
        },
      ]);
    }
  }, [
    SPCtagClickebleData,
    SPCtagClickebleData,
    params.deviceId,
    params.plantid,
  ]);

  const dateFormat = "YYYY-MM-DD";
  const timeFormat = "HH:mm:ss";

  // Use useMemo to prevent infinite re-renders when these are in useEffect dependencies
  const formatStartDate = useMemo(
    () =>
      smartTagCOCStartDate
        ? dayjs(smartTagCOCStartDate).format(dateFormat)
        : "",
    [smartTagCOCStartDate]
  );
  const formatEndDate = useMemo(
    () =>
      smartTagCOCEndDate ? dayjs(smartTagCOCEndDate).format(dateFormat) : "",
    [smartTagCOCEndDate]
  );

  const formatStartTime = useMemo(
    () =>
      smartTagCOCStartDate
        ? dayjs(smartTagCOCStartDate).format(timeFormat)
        : "",
    [smartTagCOCStartDate]
  );
  const formatEndTime = useMemo(
    () =>
      smartTagCOCEndDate ? dayjs(smartTagCOCEndDate).format(timeFormat) : "",
    [smartTagCOCEndDate]
  );

  const formatStartDatePOP = useMemo(
    () =>
      smartTagPOPStartDate
        ? dayjs(smartTagPOPStartDate).format(dateFormat)
        : "",
    [smartTagPOPStartDate]
  );
  const formatEndDatePOP = useMemo(
    () =>
      smartTagPOPEndDate ? dayjs(smartTagPOPEndDate).format(dateFormat) : "",
    [smartTagPOPEndDate]
  );

  const formatStartTimePOP = useMemo(
    () =>
      smartTagPOPStartDate
        ? dayjs(smartTagPOPStartDate).format(timeFormat)
        : "",
    [smartTagPOPStartDate]
  );
  const formatEndTimePOP = useMemo(
    () =>
      smartTagPOPEndDate ? dayjs(smartTagPOPEndDate).format(timeFormat) : "",
    [smartTagPOPEndDate]
  );

  const formatStartDatePOP1 = useMemo(
    () =>
      smartTagPOP1StartDate
        ? dayjs(smartTagPOP1StartDate).format(dateFormat)
        : "",
    [smartTagPOP1StartDate]
  );
  const formatEndDatePOP1 = useMemo(
    () =>
      smartTagPOP1EndDate ? dayjs(smartTagPOP1EndDate).format(dateFormat) : "",
    [smartTagPOP1EndDate]
  );

  const formatStartTimePOP1 = useMemo(
    () =>
      smartTagPOP1StartDate
        ? dayjs(smartTagPOP1StartDate).format(timeFormat)
        : "",
    [smartTagPOP1StartDate]
  );
  const formatEndTimePOP1 = useMemo(
    () =>
      smartTagPOP1EndDate ? dayjs(smartTagPOP1EndDate).format(timeFormat) : "",
    [smartTagPOP1EndDate]
  );
  const notifyError = (message) =>
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION.TOP_RIGHT,
      toastClassName: "custom-toast",
    });

  const handleToggleTime = () => {
    setSmartTagCOCTime(!smartTagCOCTime);
  };

  const MAX_DATE_RANGE_DAYS = 365;

  // CRITICAL FIX: Use useMemo to prevent dayjs objects from being recreated on every render
  // These are used in handleStartDate/handleEndDate and were causing infinite re-renders
  const startDateReFormat = useMemo(
    () => (smartTagCOCStartDate ? dayjs(smartTagCOCStartDate) : null),
    [smartTagCOCStartDate]
  );
  const endDateReFormat = useMemo(
    () => (smartTagCOCEndDate ? dayjs(smartTagCOCEndDate) : null),
    [smartTagCOCEndDate]
  );

  const startDateRePOPFormat = useMemo(
    () => (smartTagPOPStartDate ? dayjs(smartTagPOPStartDate) : null),
    [smartTagPOPStartDate]
  );
  const endDateRePOPFormat = useMemo(
    () => (smartTagPOPEndDate ? dayjs(smartTagPOPEndDate) : null),
    [smartTagPOPEndDate]
  );

  const startDateRePOP1Format = useMemo(
    () => (smartTagPOP1StartDate ? dayjs(smartTagPOP1StartDate) : null),
    [smartTagPOP1StartDate]
  );
  const endDateRePOP1Format = useMemo(
    () => (smartTagPOP1EndDate ? dayjs(smartTagPOP1EndDate) : null),
    [smartTagPOP1EndDate]
  );

  const handleStartDate = useCallback(
    (newValue) => {
      const durationInDays = endDateReFormat
        ? endDateReFormat.diff(newValue, "days")
          ? endDateReFormat.diff(newValue, "days") > 0
            ? endDateReFormat.diff(newValue, "days")
            : 1
          : 1
        : MAX_DATE_RANGE_DAYS;

      if (!(durationInDays > 0 && durationInDays <= MAX_DATE_RANGE_DAYS)) {
        setSmartTagCOCStartDate(null);
        notifyError("Date range must be within one year");
        return true;
      }

      if (endDateReFormat && newValue.isBefore(endDateReFormat)) {
        setSmartTagCOCStartDate(newValue);
      } else if (!endDateReFormat) {
        setSmartTagCOCStartDate(newValue);
      } else if (endDateReFormat && newValue.isSame(endDateReFormat, "day")) {
        // Check for time validation if showTime is true
        if (
          smartTagCOCTime &&
          (newValue.hour() > endDateReFormat.hour() ||
            (newValue.hour() === endDateReFormat.hour() &&
              newValue.minute() >= endDateReFormat.minute()))
        ) {
          setSmartTagCOCStartDate(null);
          notifyError("Start time must be before end time");
        } else {
          setSmartTagCOCStartDate(newValue);
        }
      } else {
        setSmartTagCOCStartDate(null);
        dispatch(setSmartTagReportData({ smartTagCOCStartDate: null }));
        notifyError("End date must be greater than start date");
      }
    },
    [endDateReFormat, smartTagCOCTime, dispatch]
  );

  const handleEndDate = useCallback(
    (newValue) => {
      const durationInDays = startDateReFormat
        ? startDateReFormat.diff(newValue, "days")
          ? startDateReFormat.diff(newValue, "days") > 0
            ? startDateReFormat.diff(newValue, "days")
            : 1
          : 1
        : MAX_DATE_RANGE_DAYS;

      if (!(durationInDays > 0 && durationInDays <= MAX_DATE_RANGE_DAYS)) {
        setSmartTagCOCEndDate(null);
        notifyError("Date range must be within one year");
        return true;
      }

      if (startDateReFormat && newValue.isAfter(startDateReFormat)) {
        setSmartTagCOCEndDate(newValue);
      } else if (!startDateReFormat) {
        setSmartTagCOCEndDate(newValue);
      } else if (
        startDateReFormat &&
        newValue.isSame(startDateReFormat, "day")
      ) {
        // Check for time validation if showTime is true
        if (
          smartTagCOCTime &&
          (newValue.hour() < startDateReFormat.hour() ||
            (newValue.hour() === startDateReFormat.hour() &&
              newValue.minute() <= startDateReFormat.minute()))
        ) {
          setSmartTagCOCEndDate(null);
          notifyError("End time must be after start time");
        } else {
          setSmartTagCOCEndDate(newValue);
        }
      } else {
        setSmartTagCOCEndDate(null);
        notifyError("Start date must be less than end date");
      }
    },
    [startDateReFormat, smartTagCOCTime]
  );

  // POP handle date
  const handlePOPStartDate = useCallback(
    (newValue) => {
      const durationInDays = endDateRePOPFormat
        ? endDateRePOPFormat.diff(newValue, "days")
          ? endDateRePOPFormat.diff(newValue, "days") > 0
            ? endDateRePOPFormat.diff(newValue, "days")
            : 1
          : 1
        : MAX_DATE_RANGE_DAYS;

      if (!(durationInDays > 0 && durationInDays <= MAX_DATE_RANGE_DAYS)) {
        setSmartTagPOPStartDate(null);
        notifyError("Date range must be within one year");
        return true;
      }

      if (endDateRePOPFormat && newValue.isBefore(endDateRePOPFormat)) {
        setSmartTagPOPStartDate(newValue);
      } else if (!endDateRePOPFormat) {
        setSmartTagPOPStartDate(newValue);
      } else if (
        endDateRePOPFormat &&
        newValue.isSame(endDateRePOPFormat, "day")
      ) {
        // Check for time validation if showTime is true
        if (
          smartTagPOPTime &&
          (newValue.hour() > endDateRePOPFormat.hour() ||
            (newValue.hour() === endDateRePOPFormat.hour() &&
              newValue.minute() >= endDateRePOPFormat.minute()))
        ) {
          setSmartTagPOPStartDate(null);
          notifyError("Start time must be before end time");
        } else {
          setSmartTagPOPStartDate(newValue);
        }
      } else {
        setSmartTagPOPStartDate(null);
        notifyError("End date must be greater than start date");
      }
    },
    [endDateRePOPFormat, smartTagPOPTime]
  );

  const handlePOPEndDate = useCallback(
    (newValue) => {
      const durationInDays = startDateRePOPFormat
        ? startDateRePOPFormat.diff(newValue, "days")
          ? startDateRePOPFormat.diff(newValue, "days") > 0
            ? startDateRePOPFormat.diff(newValue, "days")
            : 1
          : 1
        : MAX_DATE_RANGE_DAYS;

      if (!(durationInDays > 0 && durationInDays <= MAX_DATE_RANGE_DAYS)) {
        setSmartTagPOPEndDate(null);
        notifyError("Date range must be within one year");
        return true;
      }

      if (startDateRePOPFormat && newValue.isAfter(startDateRePOPFormat)) {
        setSmartTagPOPEndDate(newValue);
      } else if (!startDateRePOPFormat) {
        setSmartTagPOPEndDate(newValue);
      } else if (
        startDateRePOPFormat &&
        newValue.isSame(startDateRePOPFormat, "day")
      ) {
        // Check for time validation if showTime is true
        if (
          smartTagPOPTime &&
          (newValue.hour() < startDateRePOPFormat.hour() ||
            (newValue.hour() === startDateRePOPFormat.hour() &&
              newValue.minute() <= startDateRePOPFormat.minute()))
        ) {
          setSmartTagPOPEndDate(null);
          notifyError("End time must be after start time");
        } else {
          setSmartTagPOPEndDate(newValue);
        }
      } else {
        setSmartTagPOPEndDate(null);
        notifyError("Start date must be less than end date");
      }
    },
    [startDateRePOPFormat, smartTagPOPTime]
  );

  const handlePOPToggleTime = () => {
    setSmartTagPOPTime(!smartTagPOPTime);
  };

  useEffect(() => {
    addInteractionData();
    addInteractionData1()
  }, [smartTagCOCSelectTag, smartTagPOPSelectTag]);

  const addInteractionData = async () => {
    const param = {
      plant: params.plantid,
      tag: smartTagCOCSelectTag?.map((e) => e.tagId)
    };
    try {
      const resp = await tagInteractionData(param);
      if (resp.status == 200 || resp.status == 201) {
        console.log("Interaction tag successfully");
      }
    } catch (error) {
      console.log("handlesubmit", error);
    }
  };

  const addInteractionData1 = async () => {
    const param = {
      plant: params.plantid,
      tag: smartTagPOPSelectTag?.map((e) => e.tagId)
    };
    try {
      const resp = await tagInteractionData(param);
      if (resp.status == 200 || resp.status == 201) {
        console.log("Interaction tag successfully");
      }
    } catch (error) {
      console.log("handlesubmit", error);
    }
  };

  useEffect(() => {
    if (smartTagCOCSwitch) {
      // Calculate and set 24-hour difference for start and end dates
      const currentDate = new Date();
      const startDate = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000); // 24 hours ago
      const endDate = currentDate;

      setSmartTagCOCStartDate(startDate);
      setSmartTagCOCEndDate(endDate);
      // setSmartTagCOCTime(true)
    } else {
      // When the switch is off, clear the start and end dates
      setSmartTagCOCStartDate(null);
      setSmartTagCOCEndDate(null);
      // setSmartTagCOCTime(false)
    }
  }, [smartTagCOCSwitch]);

  useEffect(() => {
    if (smartTagPOPSwitch) {
      // Calculate and set 24-hour difference for start and end dates
      const currentDate = new Date();
      const startDate = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000); // 24 hours ago
      const endDate = currentDate;
      setSmartTagPOPStartDate(startDate);
      setSmartTagPOPEndDate(endDate);
      setSmartTagPOP1StartDate(startDate);
      setSmartTagPOP1EndDate(endDate);
    } else {
      // When the switch is off, clear the start and end dates
      setSmartTagPOPStartDate(null);
      setSmartTagPOPEndDate(null);
      setSmartTagPOP1StartDate(null);
      setSmartTagPOP1EndDate(null);
    }
  }, [smartTagPOPSwitch]);

  useEffect(() => {
    GetSmartTagMachine();
  }, []);

  // Auto-select and call APIs for ANALYTICS tab based on SPCTopBarTagData or SPCtagClickebleData from Redux
  useEffect(() => {
    // Only run for analytics tab
    if (activeSPCClass !== "analytics") {
      return;
    }

    // Reset ref when Redux data actually changes (not just on every render)
    const dataChanged =
      prevSPCTopBarTagDataRef.current !== SPCTopBarTagData ||
      JSON.stringify(prevSPCtagClickebleDataRef.current) !==
      JSON.stringify(SPCtagClickebleData);
    if (dataChanged) {
      hasAutoSelectedFromReduxAnalyticsRef.current = false;
      prevSPCTopBarTagDataRef.current = SPCTopBarTagData;
      prevSPCtagClickebleDataRef.current = SPCtagClickebleData;
    }

    // Check if we've already auto-selected to prevent infinite loops
    if (hasAutoSelectedFromReduxAnalyticsRef.current || !Machines?.length) {
      return;
    }

    // Priority 1: Check if SPCTopBarTagData is available with all required fields
    let machineId, tagUnit, tagId;
    let useTopBarData = false;

    if (
      SPCTopBarTagData &&
      SPCTopBarTagData.device_id &&
      SPCTopBarTagData.tag_id &&
      SPCTopBarTagData.tag_unit
    ) {
      // Use SPCTopBarTagData
      machineId = SPCTopBarTagData.device_id;
      tagUnit = SPCTopBarTagData.tag_unit;
      tagId = SPCTopBarTagData.tag_id;
      useTopBarData = true;
    } else if (SPCtagClickebleData?.length) {
      // Priority 2: Fall back to SPCtagClickebleData
      const spcData = SPCtagClickebleData.find(
        (f) => f.plantId == params.plantid
      );

      if (!spcData) {
        return;
      }

      machineId = spcData.machineId;
      tagUnit = spcData.tagUnit;
      tagId = spcData.tagId;
    } else {
      // No data available
      return;
    }

    // Find matching machine from Machines array
    const matchingMachine = Machines.find(
      (machine) => machine.device == machineId
    );

    if (!matchingMachine) {
      return;
    }

    // Get device name - prefer from SPCTopBarTagData if available, otherwise from matchingMachine
    const deviceName =
      useTopBarData && SPCTopBarTagData?.device_name
        ? SPCTopBarTagData.device_name
        : matchingMachine.device__device_name;

    // Check if machine is already selected
    const isMachineSelected = params.deviceId
      ? selectDeviceData.some(
        (d) => d.machineId == machineId && d.plantId == params.plantid
      )
      : smartTagCOCSelectMachine.some(
        (d) => d.machineId == machineId && d.plantId == params.plantid
      );

    // If machine not selected, select it and trigger unit API
    if (!isMachineSelected) {
      // Select machine
      if (params.deviceId) {
        setSelectDeviceData([
          {
            machineId: machineId,
            plantId: params.plantid,
            dvName: deviceName,
          },
        ]);
      } else {
        const newMachine = {
          machineId: machineId,
          plantId: params.plantid,
          dvName: deviceName,
        };
        setSmartTagCOCSelectMachine((prevState) => {
          // Remove existing machine for this plant and add new one
          const filtered = prevState.filter((f) => f.plantId != params.plantid);
          return [...filtered, newMachine];
        });
      }

      // Call handleGetUnitsData to get units for this device
      handleGetUnitsData([machineId]);
    }

    // Once units are loaded, select the unit and trigger tag API
    if (unitsData.length > 0 && tagUnit) {
      // Handle both string array and object array formats
      const matchingUnit = unitsData.find((unit) => {
        if (typeof unit === "string") {
          return unit.toLowerCase() === tagUnit.toLowerCase();
        } else if (unit && typeof unit === "object" && unit.tag_unit) {
          return unit.tag_unit.toLowerCase() === tagUnit.toLowerCase();
        }
        return false;
      });

      // Extract the actual unit value (string or from object)
      const unitValue =
        typeof matchingUnit === "string"
          ? matchingUnit
          : matchingUnit?.tag_unit || tagUnit;

      console.log("Auto-select unit check:", {
        tagUnit,
        unitsData,
        matchingUnit,
        unitValue,
      });

      if (matchingUnit) {
        const isUnitSelected = params.deviceId
          ? selectUnitData.some(
            (u) =>
              u.tagUnit?.toLowerCase() === tagUnit.toLowerCase() &&
              u.plantId == params.plantid
          )
          : smartTagCOCSelectUnit.some(
            (u) =>
              u.tagUnit?.toLowerCase() === tagUnit.toLowerCase() &&
              u.plantId == params.plantid
          );

        if (!isUnitSelected) {
          // Select unit (this will trigger getTagListData via existing useEffect)
          if (params.deviceId) {
            const newUnit = {
              tagUnit: unitValue,
              machineId: machineId,
              plantId: params.plantid,
            };
            setSelectUnitData((prevState) => {
              const filtered = prevState.filter(
                (f) => f.plantId != params.plantid
              );
              return [...filtered, newUnit];
            });
          } else {
            const newUnit = {
              tagUnit: unitValue,
              machineId: machineId,
              plantId: params.plantid,
            };
            setSmartTagCOCSelectUnit((prevState) => {
              const filtered = prevState.filter(
                (f) => f.plantId != params.plantid
              );
              return [...filtered, newUnit];
            });
          }
        }
      }
    }

    // Once tags are loaded, select the tag
    if (tagListData.length > 0 && tagId) {
      const matchingTag = tagListData.find((tag) => tag.id == tagId);

      if (matchingTag) {
        const isTagSelected = params.deviceId
          ? selectTagData.some(
            (t) => t.tagId == tagId && t.plantId == params.plantid
          )
          : smartTagCOCSelectTag.some(
            (t) => t.tagId == tagId && t.plantId == params.plantid
          );

        if (!isTagSelected) {
          // Find tag color from tagListData (tags have colors assigned)
          // Use Steel Blue as default for first auto-selected tag
          const tagColor = matchingTag.color || "#4A90E2";

          // Get tag name - prefer from SPCTopBarTagData if available, otherwise from matchingTag
          const tagName =
            useTopBarData && SPCTopBarTagData?.tag_comment
              ? SPCTopBarTagData.tag_comment
              : matchingTag.tag_name;

          // Select tag
          if (params.deviceId) {
            setSelectTagData([
              {
                tagId: tagId,
                tagName: tagName,
                tagUnit: tagUnit,
                machineId: machineId,
                plantId: params.plantid,
                color: tagColor,
              },
            ]);
          } else {
            const newTag = {
              tagId: tagId,
              tagName: tagName,
              tagUnit: tagUnit,
              machineId: machineId,
              plantId: params.plantid,
              color: tagColor,
            };
            setSmartTagCOCSelectTag((prevState) => {
              const filtered = prevState.filter(
                (f) => f.plantId != params.plantid
              );
              return [...filtered, newTag];
            });
          }

          // Mark as completed to prevent re-running
          hasAutoSelectedFromReduxAnalyticsRef.current = true;
        }
      }
    }
  }, [
    SPCTopBarTagData,
    SPCtagClickebleData,
    Machines,
    unitsData,
    tagListData,
    params.deviceId,
    params.plantid,
    activeSPCClass, // Add activeSPCClass to handle tab switching
  ]);

  // Auto-select and call APIs for REPORTS tab based on SPCTopBarTagData or SPCtagClickebleData from Redux
  useEffect(() => {
    // Only run for reports tab
    if (activeSPCClass !== "reports") {
      return;
    }

    // Reset ref when Redux data actually changes (not just on every render)
    const dataChanged =
      prevSPCTopBarTagDataRef.current !== SPCTopBarTagData ||
      JSON.stringify(prevSPCtagClickebleDataRef.current) !==
      JSON.stringify(SPCtagClickebleData);
    if (dataChanged) {
      hasAutoSelectedFromReduxReportsRef.current = false;
      prevSPCTopBarTagDataRef.current = SPCTopBarTagData;
      prevSPCtagClickebleDataRef.current = SPCtagClickebleData;
    }

    // Check if we've already auto-selected to prevent infinite loops
    if (hasAutoSelectedFromReduxReportsRef.current || !Machines?.length) {
      return;
    }

    // Priority 1: Check if SPCTopBarTagData is available with all required fields
    let machineId, tagUnit, tagId;
    let useTopBarData = false;

    if (
      SPCTopBarTagData &&
      SPCTopBarTagData.device_id &&
      SPCTopBarTagData.tag_id &&
      SPCTopBarTagData.tag_unit
    ) {
      // Use SPCTopBarTagData
      machineId = SPCTopBarTagData.device_id;
      tagUnit = SPCTopBarTagData.tag_unit;
      tagId = SPCTopBarTagData.tag_id;
      useTopBarData = true;
    } else if (SPCtagClickebleData?.length) {
      // Priority 2: Fall back to SPCtagClickebleData
      const spcData = SPCtagClickebleData.find(
        (f) => f.plantId == params.plantid
      );

      if (!spcData) {
        return;
      }

      machineId = spcData.machineId;
      tagUnit = spcData.tagUnit;
      tagId = spcData.tagId;
    } else {
      // No data available
      return;
    }

    // Find matching machine from Machines array
    const matchingMachine = Machines.find(
      (machine) => machine.device == machineId
    );

    if (!matchingMachine) {
      return;
    }

    // Get device name - prefer from SPCTopBarTagData if available, otherwise from matchingMachine
    const deviceName =
      useTopBarData && SPCTopBarTagData?.device_name
        ? SPCTopBarTagData.device_name
        : matchingMachine.device__device_name;

    // Check if machine is already selected (for reports tab)
    const isMachineSelected = params.deviceId
      ? selectPOPDeviceData.some(
        (d) => d.machineId == machineId && d.plantId == params.plantid
      )
      : smartTagPOPSelectMachine.some(
        (d) => d.machineId == machineId && d.plantId == params.plantid
      );

    // If machine not selected, select it and trigger unit API
    if (!isMachineSelected) {
      // Select machine for reports tab
      if (params.deviceId) {
        setSelectPOPDeviceData([
          {
            machineId: machineId,
            plantId: params.plantid,
            dvName: deviceName,
          },
        ]);
      } else {
        const newMachine = {
          machineId: machineId,
          plantId: params.plantid,
          dvName: deviceName,
        };
        setSmartTagPOPSelectMachine((prevState) => {
          // Remove existing machine for this plant and add new one
          const filtered = prevState.filter((f) => f.plantId != params.plantid);
          return [...filtered, newMachine];
        });
      }

      // Call handleGetUnitsData to get units for this device
      handleGetUnitsData([machineId]);
    }

    // Once units are loaded, select the unit and trigger tag API
    if (unitsData.length > 0 && tagUnit) {
      // Handle both string array and object array formats
      const matchingUnit = unitsData.find((unit) => {
        if (typeof unit === "string") {
          return unit.toLowerCase() === tagUnit.toLowerCase();
        } else if (unit && typeof unit === "object" && unit.tag_unit) {
          return unit.tag_unit.toLowerCase() === tagUnit.toLowerCase();
        }
        return false;
      });

      // Extract the actual unit value (string or from object)
      const unitValue =
        typeof matchingUnit === "string"
          ? matchingUnit
          : matchingUnit?.tag_unit || tagUnit;

      if (matchingUnit) {
        const isUnitSelected = params.deviceId
          ? selectPOPUnitData.some(
            (u) =>
              u.tagUnit?.toLowerCase() === tagUnit.toLowerCase() &&
              u.plantId == params.plantid
          )
          : smartTagPOPSelectUnit.some(
            (u) =>
              u.tagUnit?.toLowerCase() === tagUnit.toLowerCase() &&
              u.plantId == params.plantid
          );

        if (!isUnitSelected) {
          // Select unit for reports tab (this will trigger getTagListData1 via existing useEffect)
          if (params.deviceId) {
            const newUnit = {
              tagUnit: unitValue,
              machineId: machineId,
              plantId: params.plantid,
            };
            setSelectPOPUnitData((prevState) => {
              const filtered = prevState.filter(
                (f) => f.plantId != params.plantid
              );
              return [...filtered, newUnit];
            });
          } else {
            const newUnit = {
              tagUnit: unitValue,
              machineId: machineId,
              plantId: params.plantid,
            };
            setSmartTagPOPSelectUnit((prevState) => {
              const filtered = prevState.filter(
                (f) => f.plantId != params.plantid
              );
              return [...filtered, newUnit];
            });
          }
        }
      }
    }

    // Once tags are loaded, select the tag (for reports tab, use tagListData1)
    if (tagListData1.length > 0 && tagId) {
      const matchingTag = tagListData1.find((tag) => tag.id == tagId);

      if (matchingTag) {
        const isTagSelected = params.deviceId
          ? selectPOPTagData.some(
            (t) => t.tagId == tagId && t.plantId == params.plantid
          )
          : smartTagPOPSelectTag.some(
            (t) => t.tagId == tagId && t.plantId == params.plantid
          );

        if (!isTagSelected) {
          // Find tag color from tagListData1 (tags have colors assigned)
          // Use Steel Blue as default for first auto-selected tag in reports
          const tagColor = matchingTag.color || "#4A90E2";

          // Get tag name - prefer from SPCTopBarTagData if available, otherwise from matchingTag
          const tagName =
            useTopBarData && SPCTopBarTagData?.tag_comment
              ? SPCTopBarTagData.tag_comment
              : matchingTag.tag_name;

          // Select tag for reports tab
          if (params.deviceId) {
            setSelectPOPTagData((prevState) => {
              const currentPlantTags = prevState.filter(
                (tag) => tag.plantId === params.plantid
              );
              // Reports mode allows up to 2 tags per plant
              if (currentPlantTags.length < 2) {
                return [
                  ...prevState,
                  {
                    tagId: tagId,
                    tagName: tagName,
                    tagUnit: tagUnit,
                    machineId: machineId,
                    plantId: params.plantid,
                    color: tagColor,
                  },
                ];
              }
              return prevState;
            });
          } else {
            setSmartTagPOPSelectTag((prevState) => {
              const currentPlantTags = prevState.filter(
                (tag) => tag.plantId === params.plantid
              );
              // Reports mode allows up to 2 tags per plant
              if (currentPlantTags.length < 2) {
                const newTag = {
                  tagId: tagId,
                  tagName: tagName,
                  tagUnit: tagUnit,
                  machineId: machineId,
                  plantId: params.plantid,
                  color: tagColor,
                };
                const filterOldData = prevState.filter(
                  (f) => f.plantId != params.plantid
                );
                return [...filterOldData, ...currentPlantTags, newTag];
              }
              return prevState;
            });
          }

          // Mark as completed to prevent re-running
          hasAutoSelectedFromReduxReportsRef.current = true;
        }
      }
    }
  }, [
    activeSPCClass,
    SPCTopBarTagData,
    SPCtagClickebleData,
    Machines,
    unitsData,
    tagListData1, // Use tagListData1 for reports tab
    params.deviceId,
    params.plantid,
  ]);

  // Transform I Chart API response data to chart format
  const transformAnalyticsIChartData = (apiData) => {
    if (!apiData || !apiData.data) return [];

    return apiData.data
      .map((item) => {
        // Extract time from MIN_KEY or created_at
        const timeStr = item.MIN_KEY || item.created_at;
        if (!timeStr) return null;

        const date = new Date(timeStr);
        if (isNaN(date.getTime())) return null;

        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const seconds = date.getSeconds().toString().padStart(2, "0");
        const timeString = `${hours}:${minutes}:${seconds}`;

        // Check if there are rule breaks (violations)
        const isViolation = item.rule_break && item.rule_break.length > 0;

        // Handle null/undefined tag_value
        const tagValue =
          item.tag_value != null ? parseFloat(item.tag_value) : null;
        if (tagValue === null || isNaN(tagValue)) return null;

        return {
          tagValue: tagValue,
          tagTime: timeString,
          isViolation: isViolation,
          ruleBreak:
            item.rule_break && Array.isArray(item.rule_break)
              ? item.rule_break
              : [],
        };
      })
      .filter((item) => item !== null); // Filter out any null items
  };

  // Transform MR Chart API response data to chart format
  const transformAnalyticsMRChartData = (apiData) => {
    if (!apiData || !apiData.data) return [];

    return apiData.data
      .map((item) => {
        // Extract time from MIN_KEY or created_at
        const timeStr = item.MIN_KEY || item.created_at;
        if (!timeStr) return null;

        const date = new Date(timeStr);
        if (isNaN(date.getTime())) return null;

        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const seconds = date.getSeconds().toString().padStart(2, "0");
        const timeString = `${hours}:${minutes}:${seconds}`;

        // Check if there are rule breaks (violations)
        const isViolation = item.rule_break && item.rule_break.length > 0;

        // Handle MR value: API returns tag_value which contains MR values in MR Chart response
        const mrValue =
          item.tag_value != null ? parseFloat(item.tag_value) : null;
        if (mrValue === null || isNaN(mrValue)) return null;

        return {
          tagValue: mrValue,
          tagTime: timeString,
          isViolation: isViolation,
          ruleBreak:
            item.rule_break && Array.isArray(item.rule_break)
              ? item.rule_break
              : [],
        };
      })
      .filter((item) => item !== null); // Filter out any null items
  };

  // Fetch Analytics I Chart data
  const fetchAnalyticsIChartData = async (tagId, startDate, endDate = null) => {
    const interval = analyticsIChartInterval;

    const param = {
      company_id: parseInt(params.companyid),
      plant_id: parseInt(params.plantid),
      tag_id: parseInt(tagId),
      interval: parseInt(interval),
      start_date: startDate,
    };

    // Add end_date if provided
    if (endDate) {
      param.end_date = endDate;
    }

    try {
      const resp = await getAnalyticsIChartDetail(param);
      if (resp.status == 200 || resp.status == 201) {
        const payload = resp.data.payload;

        // Update control limit values from API response
        if (payload.cl_value !== undefined && payload.cl_value !== null) {
          setAnalyticsIChartCl(Number(payload.cl_value));
        }
        if (payload.ucl_value !== undefined && payload.ucl_value !== null) {
          setAnalyticsIChartUcl(Number(payload.ucl_value));
        }
        if (payload.lcl_value !== undefined && payload.lcl_value !== null) {
          setAnalyticsIChartLcl(Number(payload.lcl_value));
        }

        // Update tag name
        if (payload.tag_name) {
          setAnalyticsTagName(payload.tag_name);
        }

        // Transform and update graph data
        const transformedData = transformAnalyticsIChartData(payload);

        // Always replace data (no polling - one-time API calls)
        setAnalyticsIChartData(transformedData);
      }
    } catch (error) {
      console.log("Error fetching Analytics I Chart data:", error);
    }
  };

  // Fetch Analytics MR Chart data
  const fetchAnalyticsMRChartData = async (
    tagId,
    startDate,
    endDate = null
  ) => {
    const interval = analyticsMRChartInterval;

    const param = {
      company_id: parseInt(params.companyid),
      plant_id: parseInt(params.plantid),
      tag_id: parseInt(tagId),
      interval: parseInt(interval),
      start_date: startDate,
    };

    // Add end_date if provided
    if (endDate) {
      param.end_date = endDate;
    }

    try {
      const resp = await getAnalyticsMRChartDetail(param);
      if (resp.status == 200 || resp.status == 201) {
        const payload = resp.data.payload;

        // Update control limit values from API response
        if (payload.cl_value !== undefined && payload.cl_value !== null) {
          setAnalyticsMRChartCl(Number(payload.cl_value));
        }
        if (payload.ucl_value !== undefined && payload.ucl_value !== null) {
          setAnalyticsMRChartUcl(Number(payload.ucl_value));
        }
        if (payload.lcl_value !== undefined && payload.lcl_value !== null) {
          setAnalyticsMRChartLcl(Number(payload.lcl_value));
        }

        // Transform and update graph data
        const transformedData = transformAnalyticsMRChartData(payload);

        // Always replace data (no polling - one-time API calls)
        setAnalyticsMRChartData(transformedData);
      }
    } catch (error) {
      console.log("Error fetching Analytics MR Chart data:", error);
    }
  };

  const GetSmartTagMachine = async () => {
    setisShimmerUnitlistCOC(true);
    setisShimmerMachineslistCOC(true);
    setisShimmerUnitlistPOP(true);
    setisShimmerMachineslistPOP(true);
    try {
      const param = {
        dashboard: 3,
        plant: params.plantid,
      };
      const resp = await getDeviceByDashboard(param);
      if (resp.status == 200 || resp.status == 201) {
        setMachines(resp.data.payload.device);
        setUnit(resp.data.payload.tag_unit);
        setTimeout(() => {
          setisShimmerUnitlistCOC(false);
          setisShimmerMachineslistCOC(false);
          setisShimmerUnitlistPOP(false);
          setisShimmerMachineslistPOP(false);
        }, 1000);
      }
    } catch (error) {
      setisShimmerUnitlistCOC(false);
      setisShimmerMachineslistCOC(false);
      setisShimmerUnitlistPOP(false);
      setisShimmerMachineslistPOP(false);
      console.log("Error from GetSmartTagMachine", error);
    }
  };

  const handleSelectMachine = (selectedMachine) => {
    if (params.deviceId) {
      const existingIndex = selectDeviceData.findIndex(
        (color) =>
          color.machineId === selectedMachine.device &&
          color.plantId === params.plantid
      );

      if (existingIndex !== -1) {
        const updateMachineId = [...selectDeviceData];
        updateMachineId.splice(existingIndex, 1);
        setSelectDeviceData(updateMachineId);
      } else {
        // If the machine is not selected, add it
        setSelectDeviceData((prev) => {
          return [
            ...prev,
            {
              machineId: selectedMachine.device,
              plantId: params.plantid,
              dvName: selectedMachine.device__device_name,
            },
          ];
        });
      }
    }

    const existingIndex = smartTagCOCSelectMachine.findIndex(
      (color) =>
        color.machineId === selectedMachine.device &&
        color.plantId === params.plantid
    );

    if (existingIndex !== -1) {
      const updateMachineId = [...smartTagCOCSelectMachine];
      updateMachineId.splice(existingIndex, 1);
      setSmartTagCOCSelectMachine(updateMachineId);

      const findSelectedTagUnit = smartTagCOCSelectUnit.length
        ? smartTagCOCSelectUnit.filter((f) => f.plantId != params.plantid)
        : [];
      setSmartTagCOCSelectUnit(findSelectedTagUnit);

      const findSelectedTeg = smartTagCOCSelectTag.length
        ? smartTagCOCSelectTag.filter((f) => f.plantId != params.plantid)
        : [];
      setSmartTagCOCSelectTag(findSelectedTeg);
    } else {
      // If the machine is not selected, add it
      const newMachine = {
        machineId: selectedMachine.device,
        plantId: params.plantid,
        dvName: selectedMachine.device__device_name,
      };
      // Add the object to the state array if it doesn't exist
      setSmartTagCOCSelectMachine((prevState) => [...prevState, newMachine]);
    }
  };

  const handleSelectReportsTagUnit = (selectedUnit) => {
    const requiredUnits = ["kvah", "kvarh", "kwh", "agg"];
    const unitLowerCase = selectedUnit.tag_unit.toLowerCase();
    if (params.deviceId) {
      const existingIndex = selectUnitData.findIndex(
        (color) =>
          color.tagUnit === unitLowerCase && color.plantId === params.plantid
      );

      if (existingIndex !== -1) {
        const updateMachineId = [...selectUnitData];
        updateMachineId.splice(existingIndex, 1);
        setSelectUnitData(updateMachineId);

        const hasRequiredUnitSelected = updateMachineId.some((unit) =>
          requiredUnits.includes(unit.tagUnit.toLowerCase())
        );
        setDisableOtherUnits(hasRequiredUnitSelected);
      } else {
        const newUnit = {
          tagUnit: selectedUnit.tag_unit,
          machineId: selectedUnit.device,
          plantId: params.plantid,
        };
        setSelectUnitData((prevState) => {
          const updatedUnits = [...prevState, newUnit];

          // Check if a required unit is selected
          const hasRequiredUnitSelected = updatedUnits.some((unit) =>
            requiredUnits.includes(unit.tagUnit.toLowerCase())
          );

          // Disable other units if a required unit is selected
          setDisableOtherUnits(hasRequiredUnitSelected);

          // Turn off all other switches when a required unit is selected
          if (hasRequiredUnitSelected) {
            return updatedUnits.filter((unit) =>
              requiredUnits.includes(unit.tagUnit.toLowerCase())
            ); // Keep only the required units
          }

          return updatedUnits;
        });
      }
    }

    // Check if the selected unit is already in the selected units list
    const existingIndex = smartTagCOCSelectUnit.findIndex(
      (unit) =>
        unit.tagUnit.toLowerCase() === unitLowerCase &&
        unit.plantId === params.plantid
    );

    if (existingIndex !== -1) {
      // Unselecting the unit
      const updatedUnits = [...smartTagCOCSelectUnit];
      updatedUnits.splice(existingIndex, 1); // Remove the unit from the list
      setSmartTagCOCSelectUnit(updatedUnits);

      // If no required units are selected, enable all units
      const hasRequiredUnitSelected = updatedUnits.some((unit) =>
        requiredUnits.includes(unit.tagUnit.toLowerCase())
      );
      setDisableOtherUnits(hasRequiredUnitSelected);
    } else {
      // Selecting a new unit
      const newUnit = {
        tagUnit: selectedUnit.tag_unit,
        machineId: selectedUnit.device,
        plantId: params.plantid,
      };

      setSmartTagCOCSelectUnit((prevState) => {
        const updatedUnits = [...prevState, newUnit];

        // Check if a required unit is selected
        const hasRequiredUnitSelected = updatedUnits.some((unit) =>
          requiredUnits.includes(unit.tagUnit.toLowerCase())
        );

        // Disable other units if a required unit is selected
        setDisableOtherUnits(hasRequiredUnitSelected);

        // Turn off all other switches when a required unit is selected
        if (hasRequiredUnitSelected) {
          return updatedUnits.filter((unit) =>
            requiredUnits.includes(unit.tagUnit.toLowerCase())
          ); // Keep only the required units
        }

        return updatedUnits;
      });
    }
  };

  const handleSelectReportTag = (row, color) => {
    // For analytics mode, only allow one tag selection at a time
    if (activeSPCClass === "analytics") {
      if (params.deviceId) {
        const existingIndex = selectTagData.findIndex(
          (tag) => tag.tagId === row.id && tag.plantId === params.plantid
        );

        if (existingIndex !== -1) {
          // Deselect if already selected - clear control limit values
          const updateMachineId = [...selectTagData];
          updateMachineId.splice(existingIndex, 1);
          setSelectTagData(updateMachineId);
          // Clear I Chart and MR Chart control limit values
          setAnalyticsIChartUcl(null);
          setAnalyticsIChartCl(null);
          setAnalyticsIChartLcl(null);
          setAnalyticsMRChartUcl(null);
          setAnalyticsMRChartCl(null);
          setAnalyticsMRChartLcl(null);
        } else {
          // Replace all selections with only this tag (single selection)
          setSelectTagData([
            {
              tagId: row.id,
              tagName: row.tag_name,
              tagUnit: row.tag_unit,
              machineId: row.device,
              plantId: params.plantid,
              color: color,
            },
          ]);
        }
      } else {
        const existingIndex = smartTagCOCSelectTag.findIndex(
          (tag) => tag.tagId === row.id && tag.plantId === params.plantid
        );

        if (existingIndex !== -1) {
          // Deselect if already selected - clear control limit values
          const updateMachineId = [...smartTagCOCSelectTag];
          updateMachineId.splice(existingIndex, 1);
          setSmartTagCOCSelectTag(updateMachineId);
          // Clear I Chart and MR Chart control limit values
          setAnalyticsIChartUcl(null);
          setAnalyticsIChartCl(null);
          setAnalyticsIChartLcl(null);
          setAnalyticsMRChartUcl(null);
          setAnalyticsMRChartCl(null);
          setAnalyticsMRChartLcl(null);
        } else {
          // Filter to only current plant and replace with new selection
          const filteredTags = smartTagCOCSelectTag.filter(
            (tag) => tag.plantId !== params.plantid
          );
          const newTag = {
            tagId: row.id,
            tagName: row.tag_name,
            tagUnit: row.tag_unit,
            machineId: row.device,
            plantId: params.plantid,
            color: color,
          };
          setSmartTagCOCSelectTag([...filteredTags, newTag]);
        }
      }
    } else {
      // Original logic for other modes (if any)
      if (params.deviceId) {
        const existingIndex = selectTagData.findIndex(
          (color) => color.tagId === row.id && color.plantId === params.plantid
        );

        if (existingIndex !== -1) {
          // Deselect if already selected - clear control limit values
          const updateMachineId = [...selectTagData];
          updateMachineId.splice(existingIndex, 1);
          setSelectTagData(updateMachineId);
          // Clear I Chart and MR Chart control limit values
          setAnalyticsIChartUcl(null);
          setAnalyticsIChartCl(null);
          setAnalyticsIChartLcl(null);
          setAnalyticsMRChartUcl(null);
          setAnalyticsMRChartCl(null);
          setAnalyticsMRChartLcl(null);
          // Clear tag color
          setAnalyticsTagColor(null);
        } else {
          setSelectTagData((prev) => {
            return [
              ...prev,
              {
                tagId: row.id,
                tagName: row.tag_name,
                tagUnit: row.tag_unit,
                machineId: row.device,
                plantId: params.plantid,
                color: color,
              },
            ];
          });
          // Store tag color for chart display
          setAnalyticsTagColor(color);
        }
      } else {
        const existingIndex = smartTagCOCSelectTag.findIndex(
          (color) => color.tagId === row.id && color.plantId === params.plantid
        );

        if (existingIndex !== -1) {
          // Deselect if already selected - clear control limit values
          const updateMachineId = [...smartTagCOCSelectTag];
          updateMachineId.splice(existingIndex, 1);
          setSmartTagCOCSelectTag(updateMachineId);
          // Clear I Chart and MR Chart control limit values
          setAnalyticsIChartUcl(null);
          setAnalyticsIChartCl(null);
          setAnalyticsIChartLcl(null);
          setAnalyticsMRChartUcl(null);
          setAnalyticsMRChartCl(null);
          setAnalyticsMRChartLcl(null);
          // Clear tag color
          setAnalyticsTagColor(null);
        } else {
          const newTag = {
            tagId: row.id,
            tagName: row.tag_name,
            tagUnit: row.tag_unit,
            machineId: row.device,
            plantId: params.plantid,
            color: color,
          };
          setSmartTagCOCSelectTag((prevState) => [...prevState, newTag]);
          // Store tag color for chart display
          setAnalyticsTagColor(color);
        }
      }
    }
  };

  const handlePOPSelectMachine = (selectedMachine) => {
    if (params.deviceId) {
      const existingIndex = selectPOPDeviceData.findIndex(
        (color) =>
          color.machineId === selectedMachine.device &&
          color.plantId === params.plantid
      );

      if (existingIndex !== -1) {
        const updateMachineId = [...selectPOPDeviceData];
        updateMachineId.splice(existingIndex, 1);
        setSelectPOPDeviceData(updateMachineId);
      } else {
        // If the machine is not selected, add it
        setSelectPOPDeviceData((prev) => {
          return [
            ...prev,
            {
              machineId: selectedMachine.device,
              plantId: params.plantid,
              dvName: selectedMachine.device__device_name,
            },
          ];
        });
      }
    }

    const existingIndex = smartTagPOPSelectMachine.findIndex(
      (color) =>
        color.machineId === selectedMachine.device &&
        color.plantId === params.plantid
    );

    if (existingIndex !== -1) {
      const updateMachineId = [...smartTagPOPSelectMachine];
      updateMachineId.splice(existingIndex, 1);
      setSmartTagPOPSelectMachine(updateMachineId);

      const findSelectedTagUnit = smartTagPOPSelectUnit.length
        ? smartTagPOPSelectUnit.filter((f) => f.plantId != params.plantid)
        : [];

      setSmartTagPOPSelectUnit(findSelectedTagUnit);

      const findSelectedTeg = smartTagPOPSelectTag.length
        ? smartTagPOPSelectTag.filter((f) => f.plantId != params.plantid)
        : [];

      setSmartTagPOPSelectTag(findSelectedTeg);
    } else {
      // If the machine is not selected, add it
      const newDevice = {
        machineId: selectedMachine.device,
        plantId: params.plantid,
        dvName: selectedMachine.device__device_name,
      };
      // Add the object to the state array if it doesn't exist
      setSmartTagPOPSelectMachine((prevState) => [...prevState, newDevice]);
    }
  };

  const handlePOPSelectTagUnit = (selectedUnit) => {
    const requiredUnits = ["kvah", "kvarh", "kwh", "agg"];
    const unitLowerCase = selectedUnit.tag_unit.toLowerCase();
    if (params.deviceId) {
      const existingIndex = selectPOPUnitData.findIndex(
        (color) =>
          color.tagUnit === unitLowerCase && color.plantId === params.plantid
      );

      if (existingIndex !== -1) {
        const updateMachineId = [...selectPOPUnitData];
        updateMachineId.splice(existingIndex, 1);
        setSelectUnitData(updateMachineId);

        const hasRequiredUnitSelected = updateMachineId.some((unit) =>
          requiredUnits.includes(unit.tagUnit.toLowerCase())
        );
        setDisableOtherUnitsPOP(hasRequiredUnitSelected);
      } else {
        const newUnit = {
          tagUnit: selectedUnit.tag_unit,
          machineId: selectedUnit.device,
          plantId: params.plantid,
        };
        setSelectPOPUnitData((prevState) => {
          const updatedUnits = [...prevState, newUnit];

          // Check if a required unit is selected
          const hasRequiredUnitSelected = updatedUnits.some((unit) =>
            requiredUnits.includes(unit.tagUnit.toLowerCase())
          );

          // Disable other units if a required unit is selected
          setDisableOtherUnitsPOP(hasRequiredUnitSelected);

          // Turn off all other switches when a required unit is selected
          if (hasRequiredUnitSelected) {
            return updatedUnits.filter((unit) =>
              requiredUnits.includes(unit.tagUnit.toLowerCase())
            ); // Keep only the required units
          }

          return updatedUnits;
        });
      }
    }

    const existingIndex = smartTagPOPSelectUnit.findIndex(
      (unit) =>
        unit.tagUnit.toLowerCase() === unitLowerCase &&
        unit.plantId === params.plantid
    );
    if (existingIndex !== -1) {
      const updateMachineId = [...smartTagPOPSelectUnit];
      updateMachineId.splice(existingIndex, 1);
      setSmartTagPOPSelectUnit(updateMachineId);

      const hasRequiredUnitSelected = updateMachineId.some((unit) =>
        requiredUnits.includes(unit.tagUnit.toLowerCase())
      );
      setDisableOtherUnitsPOP(hasRequiredUnitSelected);

      const findSelectedTeg = smartTagPOPSelectTag.length
        ? smartTagPOPSelectTag.filter((f) => f.plantId != params.plantid)
        : [];

      setSmartTagPOPSelectTag(findSelectedTeg);
      // dispatch(
      //   setSmartTagReportData({
      //     smartTagPOPSelectUnit: updateMachineId,
      //   })
      // );
      setTagListData([]);
    } else {
      // If the unit is not selected, add it
      const newUnit = {
        tagUnit: selectedUnit.tag_unit,
        machineId: selectedUnit.device,
        plantId: params.plantid,
      };
      // Add the object to the state array if it doesn't exist
      setSmartTagPOPSelectUnit((prevState) => {
        const updatedUnits = [...prevState, newUnit];

        // Check if a required unit is selected
        const hasRequiredUnitSelected = updatedUnits.some((unit) =>
          requiredUnits.includes(unit.tagUnit.toLowerCase())
        );

        // Disable other units if a required unit is selected
        setDisableOtherUnitsPOP(hasRequiredUnitSelected);

        // Turn off all other switches when a required unit is selected
        if (hasRequiredUnitSelected) {
          return updatedUnits.filter((unit) =>
            requiredUnits.includes(unit.tagUnit.toLowerCase())
          ); // Keep only the required units
        }

        return updatedUnits;
      });
    }
  };

  const handlePOPSelectTag = (row, color) => {
    // For reports mode, allow up to 2 tag selections
    if (activeSPCClass === "reports") {
      if (params.deviceId) {
        setSelectPOPTagData((prev) => {
          const existingIndex = prev.findIndex(
            (tag) => tag.tagId === row.id && tag.plantId === params.plantid
          );

          if (existingIndex !== -1) {
            // Deselect if already selected
            const updateMachineId = [...prev];
            updateMachineId.splice(existingIndex, 1);
            return updateMachineId;
          } else {
            // Add new tag if less than 2 are selected
            const currentPlantTags = prev.filter(
              (tag) => tag.plantId === params.plantid
            );
            // Allow up to 2 tags per plant in reports mode
            if (currentPlantTags.length < 2) {
              return [
                ...prev,
                {
                  tagId: row.id,
                  tagName: row.tag_name,
                  tagUnit: row.tag_unit,
                  machineId: row.device,
                  plantId: params.plantid,
                  color: color,
                },
              ];
            }
            return prev;
          }
        });
      } else {
        setSmartTagPOPSelectTag((prev) => {
          const existingIndex = prev.findIndex(
            (tag) => tag.tagId === row.id && tag.plantId === params.plantid
          );

          if (existingIndex !== -1) {
            // Deselect if already selected
            const updateMachineId = [...prev];
            updateMachineId.splice(existingIndex, 1);
            return updateMachineId;
          } else {
            // Filter to only current plant tags
            const currentPlantTags = prev.filter(
              (tag) => tag.plantId === params.plantid
            );

            // Add new tag if less than 2 are selected for this plant
            // Allow up to 2 tags per plant in reports mode
            if (currentPlantTags.length < 2) {
              const newTag = {
                tagId: row.id,
                tagName: row.tag_name,
                tagUnit: row.tag_unit,
                machineId: row.device,
                plantId: params.plantid,
                color: color,
              };
              // Preserve tags from other plants and add new tag for current plant
              const filterOldData = prev.filter(
                (f) => f.plantId != params.plantid
              );
              return [...filterOldData, ...currentPlantTags, newTag];
            }
            return prev;
          }
        });
      }
    } else {
      // Original logic for other modes (if any)
      const existingIndex = smartTagPOPSelectTag.findIndex(
        (color) => color.tagId === row.id && color.plantId === params.plantid
      );

      if (existingIndex !== -1) {
        const updateMachineId = [...smartTagPOPSelectTag];
        updateMachineId.splice(existingIndex, 1);
        setSmartTagPOPSelectTag(updateMachineId);
      } else {
        const oldDataTagSelected = [...smartTagPOPSelectTag];
        const filterOldData = oldDataTagSelected.filter(
          (f) => f.plantId != params.plantid
        );
        const newTag = {
          tagId: row.id,
          tagName: row.tag_name,
          tagUnit: row.tag_unit,
          machineId: row.device,
          plantId: params.plantid,
          color: color,
        };
        setSmartTagPOPSelectTag([...filterOldData, newTag]);
      }
    }
  };

  useEffect(() => {
    if (params.deviceId) {
      const findSelectedTag = selectTagData.length
        ? selectTagData
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.tagId)
        : [];

      if (
        findSelectedTag.length &&
        formatStartDate &&
        formatEndDate &&
        rangeCOC != "none" &&
        activeSPCClass == "analytics"
      ) {
        handleStoreSeletedData();
      } else {
        setCocGraphData([]);
      }
    } else {
      if (
        formatStartDate &&
        formatEndDate &&
        rangeCOC != "none" &&
        activeSPCClass == "analytics"
      ) {
        handleStoreSeletedData();
      } else {
        setCocGraphData([]);
      }
    }
  }, [
    smartTagCOCSwitch,
    smartTagCOCSelectTag,
    formatStartDate,
    formatEndDate,
    rangeCOC,
    activeSPCClass,
    smartTagCOCTime,
    formatStartTime,
    formatEndTime,
    selectTagData,
    LineCOCIntervalTime,
    aggCOC,
    COCIntervalTime,
  ]);

  // REMOVED DUPLICATE useEffect - was identical to above

  useEffect(() => {
    if (params.deviceId) {
      const findSelectedTag = selectPOPTagData.length
        ? selectPOPTagData
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.tagId)
        : [];

      if (
        findSelectedTag.length &&
        formatStartDatePOP &&
        formatEndDatePOP &&
        rangePOP != "none" &&
        // rangeModalPOP == false &&
        activeSPCClass == "reports"
      ) {
        handleStoreSeletedDataPOP();
      } else {
        setPopBarGraphData1([]);
      }
    } else {
      const findSelectedTag = smartTagPOPSelectTag.length
        ? smartTagPOPSelectTag
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.tagId)
        : [];

      if (
        findSelectedTag.length &&
        formatStartDatePOP &&
        formatEndDatePOP &&
        rangePOP != "none" &&
        // rangeModalPOP == false &&
        activeSPCClass == "reports"
      ) {
        handleStoreSeletedDataPOP();
      } else {
        setPopBarGraphData1([]);
      }
    }
  }, [
    smartTagPOPSwitch,
    smartTagPOPSelectTag,
    formatStartDatePOP,
    formatEndDatePOP,
    rangePOP,
    activeSPCClass,
    smartTagPOPTime,
    formatStartTimePOP,
    formatEndTimePOP,
    selectPOPTagData,
    aggPOP,
    POPIntervalTimePop,
  ]);
  useEffect(() => {
    if (params.deviceId) {
      const findSelectedTag = selectPOPTagData.length
        ? selectPOPTagData
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.tagId)
        : [];

      if (
        findSelectedTag.length &&
        formatStartDatePOP &&
        formatEndDatePOP &&
        rangePOP != "none" &&
        // rangeModalPOP == false &&
        activeSPCClass == "reports"
      ) {
        handleStoreSeletedDataPOP();
      } else {
        setPopBarGraphData2([]);
      }
    } else {
      const findSelectedTag = smartTagPOPSelectTag.length
        ? smartTagPOPSelectTag
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.tagId)
        : [];

      if (
        findSelectedTag.length &&
        formatStartDatePOP1 &&
        formatEndDatePOP1 &&
        rangePOP != "none" &&
        // rangeModalPOP == false &&
        activeSPCClass == "reports"
      ) {
        handleStoreSeletedDataPOP();
      } else {
        setPopBarGraphData2([]);
      }
    }
  }, [
    smartTagPOPSwitch,
    smartTagPOPSelectTag,
    formatStartDatePOP1,
    formatEndDatePOP1,
    rangePOP,
    activeSPCClass,
    smartTagPOPTime,
    formatStartTimePOP1,
    formatEndTimePOP1,
    selectPOPTagData,
    aggPOP,
    POPIntervalTimePop,
  ]);
  const handleStoreSeletedData = useCallback(async () => {
    // Get selected tags for current plant
    const selectedTagsForPlant = params.deviceId
      ? selectTagData.filter((f) => f.plantId === params.plantid)
      : smartTagCOCSelectTag.filter((f) => f.plantId === params.plantid);

    // Get device IDs as array of objects with device_id and color
    const deviceData = smartTagCOCSelectMachine.length
      ? smartTagCOCSelectMachine
        .filter((f) => f.plantId === params.plantid)
        .map((row) => ({
          device_id: row.machineId,
          color: "null",
        }))
      : [];

    // Get tag units from selected tags (from getTagList API response)
    // Extract unique tag_unit values from selected tags
    const tagUnits = selectedTagsForPlant.length
      ? selectedTagsForPlant
        .map((tag) => tag.tagUnit)
        .filter(
          (tagUnit) =>
            tagUnit !== undefined && tagUnit !== null && tagUnit !== ""
        )
        .filter((value, index, self) => self.indexOf(value) === index) // Remove duplicates
      : [];

    // Get tags with tag_id and color
    const tags = selectedTagsForPlant.length
      ? selectedTagsForPlant.map((row) => ({
        tag_id: row.tagId,
        color: row.color,
      }))
      : [];

    // Get current interval
    const currentInterval = smartTagCOCSwitch
      ? LineCOCIntervalTime
      : COCIntervalTime;

    const param = {
      company: params.companyid?.toString() || params.companyid,
      plant: params.plantid?.toString() || params.plantid,
      dashboard: 3,
      module_display_name:
        activeSPCClass === "analytics" ? "SPC Analytics" : "SPC Reposts",
      device: deviceData,
      tag_unit: tagUnits,
      tag: tags,
      interval: "5",
      is_store: smartTagCOCSwitch,
      recipe_name: [],
    };

    // Add aggrigation only if disableOtherUnits is true
    if (disableOtherUnits) {
      param["aggrigation"] = aggCOC;
    }

    try {
      const resp = await storeSelectedData(param);
      if (resp.status == 200 || resp.status == 201) {
      }
    } catch (error) {
      // Error handling
    }
  }, [
    params.companyid,
    params.plantid,
    params.deviceId,
    activeSPCClass,
    smartTagCOCSelectMachine,
    smartTagCOCSelectTag,
    selectTagData,
    smartTagCOCSwitch,
    LineCOCIntervalTime,
    COCIntervalTime,
    disableOtherUnits,
    aggCOC,
    rangeCOC,
  ]);

  // Callback to handle store API call when dropdown tags are selected in reports mode
  const handleStoreSeletedDataPOPFromDropdown = useCallback(
    async (selectedTag1Id, selectedTag2Id) => {
      // Get all available tags for current plant
      const availableTagsForPlant = params.deviceId
        ? selectPOPTagData.filter((f) => f.plantId === params.plantid)
        : smartTagPOPSelectTag.filter((f) => f.plantId === params.plantid);

      // Find tags matching the dropdown selections
      const tag1Data = availableTagsForPlant.find(
        (tag) => tag.tagId?.toString() === selectedTag1Id?.toString()
      );
      const tag2Data = availableTagsForPlant.find(
        (tag) => tag.tagId?.toString() === selectedTag2Id?.toString()
      );

      // Build selected tags array from dropdown selections
      const selectedTagsForPlant = [];
      if (tag1Data) {
        selectedTagsForPlant.push(tag1Data);
      }
      if (tag2Data) {
        selectedTagsForPlant.push(tag2Data);
      }

      // Get left_tag_unit (first tag's tagId) and right_tag_unit (second tag's tagId)
      const leftTagUnit =
        selectedTagsForPlant.length > 0 && selectedTagsForPlant[0]?.tagId
          ? selectedTagsForPlant[0].tagId
          : "none";
      const rightTagUnit =
        selectedTagsForPlant.length > 1 && selectedTagsForPlant[1]?.tagId
          ? selectedTagsForPlant[1].tagId
          : "none";

      const param = {
        company: params.companyid,
        plant: params.plantid,
        dashboard: 3,
        module_display_name:
          activeSPCClass === "analytics" ? "SPC Analytics" : "SPC Reposts",

        device: smartTagPOPSelectMachine.length
          ? smartTagPOPSelectMachine
            .filter((f) => f.plantId === params.plantid)
            .map((row) => ({
              device_id: row.machineId,
              color: "null",
            }))
          : [],

        tag_unit: smartTagPOPSelectUnit.length
          ? smartTagPOPSelectUnit
            .filter((f) => f.plantId === params.plantid)
            .map((f) => f.tagUnit)
            .filter((tagUnit) => tagUnit !== undefined)
          : [],
        tag: selectedTagsForPlant.length
          ? selectedTagsForPlant.map((row) => ({
            tag_id: row.tagId,
            color: row.color,
          }))
          : [],

        interval: "5",
        is_store: smartTagPOPSwitch,
        recipe_name: [],
        // Add left_tag_unit and right_tag_unit for reports mode
        left_tag_unit: leftTagUnit,
        right_tag_unit: rightTagUnit,
      };
      try {
        const resp = await storeSelectedData(param);
        if (resp.status == 200 || resp.status == 201) {
        }
      } catch (error) {
        // Error handling
      }
    },
    [
      params.companyid,
      params.plantid,
      params.deviceId,
      activeSPCClass,
      smartTagPOPSelectMachine,
      smartTagPOPSelectUnit,
      selectPOPTagData,
      smartTagPOPSelectTag,
      smartTagPOPSwitch,
    ]
  );

  const handleStoreSeletedDataPOP = async () => {
    // Get selected tags for current plant
    const selectedTagsForPlant = params.deviceId
      ? selectPOPTagData.filter((f) => f.plantId === params.plantid)
      : smartTagPOPSelectTag.filter((f) => f.plantId === params.plantid);

    // Get left_tag_unit (first tag's tagId) and right_tag_unit (second tag's tagId)
    // If length is 1 and same tag is selected in both dropdowns, use same tagId for both
    const leftTagUnit =
      selectedTagsForPlant.length > 0 && selectedTagsForPlant[0]?.tagId
        ? selectedTagsForPlant[0].tagId
        : "none";
    const rightTagUnit =
      selectedTagsForPlant.length === 1 && selectedTagsForPlant[0]?.tagId
        ? selectedTagsForPlant[0].tagId
        : selectedTagsForPlant.length > 1 && selectedTagsForPlant[1]?.tagId
          ? selectedTagsForPlant[1].tagId
          : "none";

    const param = {
      company: params.companyid,
      plant: params.plantid,
      dashboard: 3,
      module_display_name:
        activeSPCClass === "analytics" ? "SPC Analytics" : "SPC Reposts",

      device: smartTagPOPSelectMachine.length
        ? smartTagPOPSelectMachine.filter((f) => f.plantId === params.plantid)
          .length
          ? smartTagPOPSelectMachine
            .filter((f) => f.plantId === params.plantid)
            .map((row) => ({
              device_id: row.machineId,
              color: "null",
            }))
          : []
        : [],

      tag_unit: smartTagPOPSelectUnit.length
        ? smartTagPOPSelectUnit
          .filter((f) => f.plantId === params.plantid)
          .map((f) => f.tagUnit)
          .filter((tagUnit) => tagUnit !== undefined)
        : [],
      tag: smartTagPOPSelectTag.length
        ? smartTagPOPSelectTag.filter((f) => f.plantId === params.plantid)
          .length
          ? smartTagPOPSelectTag
            .filter((f) => f.plantId === params.plantid)
            .map((row) => ({
              tag_id: row.tagId, // Extract id as tag_id
              color: row.color, // Extract color
            }))
          : []
        : [],

      interval: "5",
      is_store: smartTagPOPSwitch,
      recipe_name: [],
      // Add left_tag_unit and right_tag_unit for reports mode
      left_tag_unit: leftTagUnit,
      right_tag_unit: rightTagUnit,
    };
    try {
      const resp = await storeSelectedData(param);
      if (resp.status == 200 || resp.status == 201) {
      }
    } catch (error) {
      // Error handling
    }
  };

  useEffect(() => {
    if (!smartTagCOCSwitch) {
      setSmartTagCOCSelectMachine([]);
      setSmartTagCOCSelectTag([]);
      setSmartTagCOCSelectUnit([]);
      setTagListData([]);
      setRangeCOC("");
      setSmartTagCOCStartDate(null);
      setSmartTagCOCEndDate(null);
      // setVmsReportTime(false)
      setLineCOCIntervalTime("1");
      setCocGraphData([]);
      setPiechartData([]);
      setPieChartSum("");
    }

    if (!smartTagPOPSwitch) {
      setSmartTagPOPSelectMachine([]);
      setSmartTagPOPSelectUnit([]);
      setSmartTagPOPSelectTag([]);
      setTagListData1([]);
      setRangePOP("");
      setSmartTagPOPStartDate(null);
      setSmartTagPOPEndDate(null);
      setSmartTagPOP1StartDate(null);
      setSmartTagPOP1EndDate(null);
      setLinePOPIntervalTime("1");
      setPopBarGraphData1([]);
      setPopBarGraphData2([]);
      setPiechartDataPOP([]);
      setPiechartDataPOP1([]);
    }
  }, [smartTagCOCSwitch, smartTagPOPSwitch, activeSPCClass]);

  useEffect(() => {
    if (activeSPCClass == "analytics") {
      handleGetStorePreviousSelectedData();
    } else if (!smartTagCOCSwitch) {
      // Reset states when the switch is off
      setSelectedPreviousData([]);
      setTagListData([]);
      setSmartTagCOCSelectMachine([]);
      setSmartTagCOCSelectTag([]);
      setSmartTagCOCSelectUnit([]);
      setRangeCOC("");
      setSmartTagCOCStartDate(null);
      setSmartTagCOCEndDate(null);
      // setVmsReportTime(false)
      setLineCOCIntervalTime("1");
      setPiechartData([]);
      setPieChartSum("");
    }
  }, [activeSPCClass]);

  useEffect(() => {
    // Ensure API call only happens when the switch is true
    if (activeSPCClass == "reports") {
      handleGetStorePreviousSelectedData();
    } else if (!smartTagPOPSwitch) {
      // Reset states when the switch is off
      setSelectedPreviousData([]);
      setSmartTagPOPSelectMachine([]);
      setSmartTagPOPSelectUnit([]);
      setSmartTagPOPSelectTag([]);
      setTagListData1([]);
      setRangePOP("");
      setSmartTagPOPStartDate(null);
      setSmartTagPOPEndDate(null);
      setSmartTagPOP1StartDate(null);
      setSmartTagPOP1EndDate(null);
      setLinePOPIntervalTime("1");
      setPopBarGraphData1([]);
      setPopBarGraphData2([]);
      setSelectPOPDeviceData([]);
      setSelectPOPUnitData([]);
      setSelectPOPTagData([]);
      setPiechartDataPOP([]);
      setPiechartDataPOP1([]);
    }
  }, [activeSPCClass]);

  const handleGetStorePreviousSelectedData = async () => {
    const requiredUnits = ["kvah", "kvarh", "kwh", "agg"];
    const param = {
      company: params.companyid,
      plant: params.plantid,
      dashboard: 3,
      module_display_name:
        activeSPCClass === "analytics" ? "SPC Analytics" : "SPC Reposts",
      device: [],
      tag_unit: [],
      tag: [],
      recipe_name: [],
    };
    try {
      const resp = await getStorePreviousSelectedData(param);
      if (resp.status == 200 || resp.status == 201) {
        setSelectedPreviousData(resp.data.payload);

        //store data COC
        if (activeSPCClass == "analytics") {
          //machine data
          const cocDeviceData = resp.data.payload?.device?.map((row) => {
            return {
              machineId: row.id,
              dvName: row.device_name,
              plantId: params.plantid,
              // deviceId: param.deviced,
            };
          });

          setSmartTagCOCSelectMachine(cocDeviceData);

          const cocTagUnitData = resp.data.payload?.tag_unit?.map((row) => {
            return {
              tagUnit: row,
              machineId: "",
              // dvName:"",
              plantId: params.plantid,
              // deviceId: param.deviceId,
            };
          });
          setSmartTagCOCSelectUnit(cocTagUnitData);

          // const newUnit = {
          //   tagUnit: row.tag_unit,
          //   machineId: row.device,
          //   dvName: row.device__device_name,
          //   plantId: param.plantId,
          //   deviceId: param.deviceId,
          // };
          // Add the object to the state array if it doesn't exist

          const cocTagDataData = resp.data.payload?.tag?.map((row) => {
            return {
              tagId: row.id,
              tagUnit: row.tag_unit,
              machineId: row.device_id,
              dvName: row.device_name,
              plantId: params.plantid,
              // deviceId: param.deviceId,
              color: row.color,
            };
          });
          // Check if any of the required units are selected
          const hasRequiredUnit = resp.data.payload?.tag_unit?.some((unit) =>
            requiredUnits.includes(unit.toLowerCase())
          );

          // Disable other units if one of the required units is found
          setDisableOtherUnits(hasRequiredUnit);

          setSmartTagCOCSelectTag(cocTagDataData);

          const IntervalData = resp.data.payload.interval;
          setLineCOCIntervalTime(IntervalData);

          const switchData = resp.data.payload?.is_store;
          setSmartTagCOCSwitch(switchData);
        } else if (activeSPCClass == "reports") {
          const POPDeviceData = resp.data.payload?.device?.map((row) => {
            return {
              machineId: row.id,
              plantId: params.plantid,
              dvName: row.device_name,
            };
          });

          setSmartTagPOPSelectMachine(POPDeviceData);

          const POPTagUnitData = resp.data.payload?.tag_unit?.map((row) => {
            return {
              tagUnit: row,
              machineId: "",
              plantId: params.plantid,
            };
          });
          setSmartTagPOPSelectUnit(POPTagUnitData);

          const POPTagDataData = resp.data.payload?.tag?.map((row) => {
            return {
              tagId: row.id,
              tagName: row.tag_name,
              tagUnit: row.tag_unit,
              machineId: row.device_id,
              plantId: params.plantid,
              color: row.color,
            };
          });
          setSmartTagPOPSelectTag(POPTagDataData);

          const hasRequiredUnit = resp.data.payload?.tag_unit?.some((unit) =>
            requiredUnits.includes(unit.toLowerCase())
          );

          setDisableOtherUnitsPOP(hasRequiredUnit);

          const IntervalData = resp.data.payload.interval;
          setLinePOPIntervalTime(IntervalData);

          const switchData = resp.data.payload?.is_store;
          setSmartTagPOPSwitch(switchData);
        }
      }
    } catch (error) {
      setSelectedPreviousData([]);
      console.log("handlesubmit", error);
    }
  };
  const getTagListData = async (selectedMachines, selectedTagUnits) => {
    try {
      setisShimmerdevicelistCOC(true);
      const params = {
        device_id: selectedMachines,
        tag_unit: selectedTagUnits,
      };

      const resp = await getTagList(params);

      if (resp.status === 200 || resp.status === 201) {
        setTimeout(() => {
          setisShimmerdevicelistCOC(false);
        }, 1000);

        setTagListData(resp.data.payload);
      }
    } catch (error) {
      // Handle API call error if needed
      setisShimmerdevicelistCOC(false);

      // Error handling
    }
  };

  useEffect(() => {
    if (params.deviceId) {
      if (selectTagData?.length > 0 && selectUnitData?.length > 0) {
        getTagListData(
          selectTagData.map((e) => e.machineId),
          selectUnitData.map((e) => e.tagUnit)
        );
      }

      if (selectUnitData.length > 0) {
        handleGetUnitsData(selectTagData.map((e) => e.machineId));

        // Check if any critical unit ("kvah", "kvarh", "kwh") is selected
        const criticalUnits = ["kvah", "kvarh", "kwh", "agg"];
        const selectedUnit = selectUnitData[0]?.tagUnit?.toLowerCase();

        const hasRequiredUnitSelected = selectUnitData.some((unit) =>
          criticalUnits.includes(selectedUnit.toLowerCase())
        );

        setDisableOtherUnits(hasRequiredUnitSelected);
      } else {
        setUnitsData([]);
      }
    } else {
      const findPlantByReportsSelectmachine = smartTagCOCSelectMachine.length
        ? smartTagCOCSelectMachine
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.machineId)
          .filter((machineId) => machineId !== undefined)
        : [];

      const findPlantByReportsSelectTagUnit = smartTagCOCSelectUnit.length
        ? smartTagCOCSelectUnit
          .filter((f) => f.plantId === params.plantid)
          .map((f) => f.tagUnit)
          .filter((tagUnit) => tagUnit !== undefined)
        : [];

      if (findPlantByReportsSelectmachine.length > 0) {
        getTagListData(
          findPlantByReportsSelectmachine,
          findPlantByReportsSelectTagUnit
        );
      } else {
        setTagListData([]);
      }

      if (findPlantByReportsSelectmachine.length > 0) {
        handleGetUnitsData(findPlantByReportsSelectmachine);
      } else {
        setUnitsData([]);
      }
    }
  }, [
    smartTagCOCSelectMachine,
    smartTagCOCSelectUnit,
    params.gatewayid,
    selectTagData,
    selectUnitData,
  ]);

  const getTagListData1 = async (selectedMachines, selectedTagUnits) => {
    setisShimmerdevicelistPOP(true);
    try {
      const params = {
        device_id: selectedMachines,
        tag_unit: selectedTagUnits,
      };

      const resp = await getTagList(params);

      if (resp.status === 200 || resp.status === 201) {
        setTimeout(() => {
          setisShimmerdevicelistPOP(false);
        }, 1000);

        setTagListData1(resp.data.payload);
      }
    } catch (error) {
      setisShimmerdevicelistPOP(false);
      // Handle API call error if needed
      // Error handling
    }
  };

  useEffect(() => {
    if (params.deviceId) {
      if (selectPOPTagData.length > 0 && selectPOPUnitData.length) {
        getTagListData1(
          selectPOPTagData.map((e) => e.machineId),
          selectPOPUnitData.map((e) => e.tagUnit)
        );
      }

      if (selectPOPUnitData.length > 0) {
        handleGetUnitsData(selectPOPTagData.map((e) => e.machineId));

        // Check if any critical unit ("kvah", "kvarh", "kwh") is selected
        const criticalUnits = ["kvah", "kvarh", "kwh", "agg"];
        const selectedUnit = selectPOPUnitData[0]?.tagUnit?.toLowerCase();

        const hasRequiredUnitSelected = selectPOPUnitData.some((unit) =>
          criticalUnits.includes(selectedUnit.toLowerCase())
        );

        setDisableOtherUnitsPOP(hasRequiredUnitSelected);
      } else {
        setUnitsData([]);
      }
    } else {
      const findPlantByReportsSelectmachine = smartTagPOPSelectMachine?.length
        ? smartTagPOPSelectMachine
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.machineId)
          .filter((machineId) => machineId !== undefined)
        : [];

      const findPlantByReportsSelectTagUnit = smartTagPOPSelectUnit?.length
        ? smartTagPOPSelectUnit
          .filter((f) => f.plantId === params.plantid)
          .map((f) => f.tagUnit)
          .filter((tagUnit) => tagUnit !== undefined)
        : [];

      if (findPlantByReportsSelectmachine.length > 0) {
        getTagListData1(
          findPlantByReportsSelectmachine,
          findPlantByReportsSelectTagUnit
        );
      } else {
        // Handle the case when no machines are selected (unselect all).
        // You may want to reset or handle the state accordingly.
        setTagListData1([]);
      }
      if (findPlantByReportsSelectmachine.length > 0) {
        handleGetUnitsData(findPlantByReportsSelectmachine);
      } else {
        setUnitsData([]);
      }
    }
  }, [
    smartTagPOPSelectMachine,
    smartTagPOPSelectUnit,
    params.gatewayid,
    selectPOPTagData,
    selectPOPUnitData,
  ]);

  // Effect to handle Analytics I Chart and MR Chart API calls (one-time calls, no polling)
  useEffect(() => {
    // Only run in analytics mode
    if (activeSPCClass !== "analytics") {
      setAnalyticsIChartData([]);
      setAnalyticsMRChartData([]);
      return;
    }

    // Get selected tag for analytics mode
    const selectedTagData =
      params.deviceId && selectTagData.length
        ? selectTagData.filter((f) => f.plantId === params.plantid)[0]
        : smartTagCOCSelectTag.length
          ? smartTagCOCSelectTag.filter((f) => f.plantId === params.plantid)[0]
          : null;

    const selectedTag = selectedTagData?.tagId || null;

    if (!selectedTag) {
      setAnalyticsIChartData([]);
      setAnalyticsMRChartData([]);
      // Clear tag color when no tag is selected
      setAnalyticsTagColor(null);
      return;
    }

    // Update tag color if tag data is available
    if (selectedTagData?.color && analyticsTagColor !== selectedTagData.color) {
      setAnalyticsTagColor(selectedTagData.color);
    }

    // Check if tag changed
    const tagChanged = analyticsCurrentTagIdRef.current !== selectedTag;

    // Clear data when tag changes
    if (tagChanged) {
      setAnalyticsIChartData([]);
      setAnalyticsMRChartData([]);
    }

    // Set start dates for each chart
    // If dates are available, use them; otherwise use current time
    let iChartStartDate;
    let mrChartStartDate;

    if (formatStartDate && formatEndDate) {
      // If time switch is ON, use inputted times (even if dates are same)
      if (smartTagCOCTime && formatStartTime && formatEndTime) {
        iChartStartDate = `${formatStartDate} ${formatStartTime}`;
        mrChartStartDate = `${formatStartDate} ${formatStartTime}`;
      } else {
        // If time switch is OFF, use 00:00:00 for start
        iChartStartDate = `${formatStartDate} 00:00:00`;
        mrChartStartDate = `${formatStartDate} 00:00:00`;
      }
    } else {
      // Use current date and time as start date when no date is selected
      iChartStartDate = dayjs().format("YYYY-MM-DD HH:mm:ss");
      mrChartStartDate = dayjs().format("YYYY-MM-DD HH:mm:ss");
    }

    // Update current tag ref
    analyticsCurrentTagIdRef.current = selectedTag;

    // Prepare end date for API call
    // If dates are available, pass end date; otherwise pass null
    let endDate = null;
    if (formatStartDate && formatEndDate) {
      if (smartTagCOCTime && formatEndTime) {
        // If time switch is ON, use inputted time
        endDate = `${formatEndDate} ${formatEndTime}`;
      } else {
        // If time switch is OFF: check if end date is today
        const endDateObj = dayjs(formatEndDate);
        const today = dayjs();
        const isToday =
          endDateObj.format("YYYY-MM-DD") === today.format("YYYY-MM-DD");

        if (isToday) {
          // End date is today: use current time
          endDate = today.format("YYYY-MM-DD HH:mm:ss");
        } else {
          // End date is past: use 23:59:59
          endDate = `${formatEndDate} 23:59:59`;
        }
      }
    }

    // Call APIs with interval value as parameter (one-time call, no polling)
    // The interval value is sent to the API but not used for automatic repeated calls
    fetchAnalyticsIChartData(selectedTag, iChartStartDate, endDate);
    fetchAnalyticsMRChartData(selectedTag, mrChartStartDate, endDate);
  }, [
    activeSPCClass,
    smartTagCOCSelectTag,
    selectTagData,
    analyticsIChartInterval,
    analyticsMRChartInterval,
    formatStartDate,
    formatEndDate,
    formatStartTime,
    formatEndTime,
    smartTagCOCTime,
    params.deviceId,
    params.plantid,
  ]);

  const getReportParatoChatAPI = async (
    tagId,
    startDate,
    endDate,
    rangeCOC,
    setState,
    smartTagCOCTime,
    startTime,
    endTime
  ) => {
    let endDateTime = `${formatEndDate} 23:59:59`;
    if (!smartTagCOCTime) {
      // Time switch is OFF: check if end date is today
      const endDateObj = dayjs(formatEndDate);
      const today = dayjs();
      const isToday =
        endDateObj.format("YYYY-MM-DD") === today.format("YYYY-MM-DD");
      if (isToday) {
        // End date is today: use current time
        endDateTime = today.format("YYYY-MM-DD HH:mm:ss");
      }
    }

    const paramReq = {
      company: params.companyid,
      plant: params.plantid,
      tag_id: tagId,
      start_date: `${formatStartDate} 00:00:00`,
      end_date: endDateTime,
    };

    if (smartTagCOCTime) {
      paramReq["start_date"] = `${formatStartDate} ${formatStartTime}`;
      paramReq["end_date"] = `${formatEndDate} ${formatEndTime}`;
    }
    try {
      getReportAPIComp(paramReq, setState, setShimmerCOC);
    } catch (error) {
      // Error handling
    }
  };

  useEffect(() => {
    // Only handle date changes for analytics mode - I Chart and MR Chart APIs
    if (activeSPCClass !== "analytics") {
      return;
    }

    // Get selected tag for analytics mode
    const selectedTag =
      params.deviceId && selectTagData.length
        ? selectTagData
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.tagId)[0]
        : smartTagCOCSelectTag.length
          ? smartTagCOCSelectTag
            .filter((f) => f.plantId === params.plantid)
            .map((row) => row.tagId)[0]
          : null;

    if (!selectedTag || !formatStartDate || !formatEndDate) {
      return;
    }

    // Format start and end dates with time
    let formattedStartDate = `${formatStartDate} 00:00:00`;
    let formattedEndDate = `${formatEndDate} 23:59:59`;

    if (smartTagCOCTime && formatStartTime && formatEndTime) {
      // If time switch is ON, use inputted times (even if dates are same)
      formattedStartDate = `${formatStartDate} ${formatStartTime}`;
      formattedEndDate = `${formatEndDate} ${formatEndTime}`;
    } else {
      // If time switch is OFF: check if end date is today
      const endDateObj = dayjs(formatEndDate);
      const today = dayjs();
      const isToday =
        endDateObj.format("YYYY-MM-DD") === today.format("YYYY-MM-DD");

      if (isToday) {
        // End date is today: use current time
        formattedEndDate = today.format("YYYY-MM-DD HH:mm:ss");
      } else {
        // End date is past: use 23:59:59
        formattedEndDate = `${formatEndDate} 23:59:59`;
      }
    }

    // Reset chart data when dates change (replace instead of append)
    setAnalyticsIChartData([]);
    setAnalyticsMRChartData([]);

    // Call I Chart and MR Chart APIs with new date range
    // The interval value is sent as a parameter but not used for polling
    fetchAnalyticsIChartData(selectedTag, formattedStartDate, formattedEndDate);
    fetchAnalyticsMRChartData(
      selectedTag,
      formattedStartDate,
      formattedEndDate
    );

    // Update current tag ref for change detection
    analyticsCurrentTagIdRef.current = selectedTag;
  }, [
    formatStartDate,
    formatEndDate,
    formatStartTime,
    formatEndTime,
    smartTagCOCTime,
    activeSPCClass,
    smartTagCOCSelectTag,
    selectTagData,
    params.deviceId,
    params.plantid,
  ]);

  const getReportAnalyticsDataAPI = async (
    tagId,
    startDate,
    endDate,
    rangeCOC,
    setState,
    smartTagCOCTime,
    startTime,
    endTime
  ) => {
    let endDateTime = `${formatEndDate} 23:59:59`;
    if (!smartTagCOCTime) {
      // Time switch is OFF: check if end date is today
      const endDateObj = dayjs(formatEndDate);
      const today = dayjs();
      const isToday =
        endDateObj.format("YYYY-MM-DD") === today.format("YYYY-MM-DD");
      if (isToday) {
        // End date is today: use current time
        endDateTime = today.format("YYYY-MM-DD HH:mm:ss");
      }
    }

    const paramReq = {
      company: params.companyid,
      plant: params.plantid,
      tag_id: tagId,
      start_date: `${formatStartDate} 00:00:00`,
      end_date: endDateTime,
      aggregate: Number(aggCOC),
    };

    if (smartTagCOCTime) {
      paramReq["start_date"] = `${formatStartDate} ${formatStartTime}`;
      paramReq["end_date"] = `${formatEndDate} ${formatEndTime}`;
    }
    try {
      getReportAPIAnalyticsData(paramReq, setState, setShimmerCOC);
    } catch (error) {
      // Error handling
    }
  };

  useEffect(() => {
    if (params.deviceId) {
      const findSelectedTag = selectTagData.length
        ? selectTagData
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.tagId)
        : [];

      if (
        disableOtherUnits &&
        findSelectedTag.length &&
        formatStartDate &&
        formatEndDate &&
        rangeCOC != "none" &&
        activeSPCClass == "analytics"
      ) {
        getReportAnalyticsDataAPI(
          findSelectedTag,
          formatStartDate,
          formatEndDate,
          rangeCOC,
          setCocGraphData,
          smartTagCOCTime,
          formatStartTime,
          formatEndTime
        );
      } else {
        setCocGraphData([]);
      }
    } else {
      const findSelectedTag = smartTagCOCSelectTag.length
        ? smartTagCOCSelectTag
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.tagId)
        : [];

      if (
        disableOtherUnits &&
        findSelectedTag.length &&
        formatStartDate &&
        formatEndDate &&
        rangeCOC != "none" &&
        activeSPCClass == "analytics"
      ) {
        getReportAnalyticsDataAPI(
          findSelectedTag,
          formatStartDate,
          formatEndDate,
          rangeCOC,
          setCocGraphData,
          smartTagCOCTime,
          formatStartTime,
          formatEndTime
        );
      } else {
        setCocGraphData([]);
      }
    }
  }, [
    disableOtherUnits,
    smartTagCOCSelectTag,
    formatStartDate,
    formatEndDate,
    rangeCOC,
    activeSPCClass,
    smartTagCOCTime,
    formatStartTime,
    formatEndTime,
    selectTagData,
    aggCOC,
  ]);

  const getPiechartCOCData = async (id) => {
    let endDateTime = `${formatEndDate} 23:59:59`;
    if (!smartTagCOCTime) {
      // Time switch is OFF: check if end date is today
      const endDateObj = dayjs(formatEndDate);
      const today = dayjs();
      const isToday =
        endDateObj.format("YYYY-MM-DD") === today.format("YYYY-MM-DD");
      if (isToday) {
        // End date is today: use current time
        endDateTime = today.format("YYYY-MM-DD HH:mm:ss");
      }
    }

    const param = {
      company: params.companyid,
      plant: params.plantid,
      tag_id: id,
      start_date: `${formatStartDate} 00:00:00`,
      end_date: endDateTime,
      aggregate: Number(aggCOC),
    };

    if (smartTagCOCTime) {
      param["start_date"] = `${formatStartDate} ${formatStartTime}`;
      param["end_date"] = `${formatEndDate} ${formatEndTime}`;
    }

    try {
      const resp = await getPiechartCOC(param);
      if (resp.status == 200 || resp.status == 201) {
        setPiechartData(resp.data.payload);
        setPieChartSum(resp.data);
      }
    } catch (error) {
      setPiechartData([]);
      setPieChartSum([]);
      console.log("handlesubmit", error);
    }
  };

  useEffect(() => {
    if (params.deviceId) {
      const findSelectedTag = selectTagData.length
        ? selectTagData
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.tagId)
        : [];

      if (
        disableOtherUnits &&
        findSelectedTag.length &&
        formatStartDate &&
        formatEndDate &&
        rangeCOC != "none" &&
        activeSPCClass == "analytics"
      ) {
        getPiechartCOCData(findSelectedTag);
      } else {
        setCocGraphData([]);
      }
    } else {
      const findSelectedTag = smartTagCOCSelectTag.length
        ? smartTagCOCSelectTag
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.tagId)
        : [];

      if (
        disableOtherUnits &&
        findSelectedTag.length &&
        formatStartDate &&
        formatEndDate &&
        rangeCOC != "none" &&
        activeSPCClass == "analytics"
      ) {
        getPiechartCOCData(findSelectedTag);
      } else {
        setCocGraphData([]);
      }
    }
  }, [
    disableOtherUnits,
    smartTagCOCSelectTag,
    formatStartDate,
    formatEndDate,
    rangeCOC,
    activeSPCClass,
    smartTagCOCTime,
    formatStartTime,
    formatEndTime,
    selectTagData,
    aggCOC,
  ]);

  const getPiechartPOPData = async (id) => {
    let endDateTime = `${formatEndDatePOP} 23:59:59`;
    if (!smartTagPOPTime) {
      // Time switch is OFF: check if end date is today
      const endDateObj = dayjs(formatEndDatePOP);
      const today = dayjs();
      const isToday =
        endDateObj.format("YYYY-MM-DD") === today.format("YYYY-MM-DD");
      if (isToday) {
        // End date is today: use current time
        endDateTime = today.format("YYYY-MM-DD HH:mm:ss");
      }
    }

    const param = {
      company: params.companyid,
      plant: params.plantid,
      tag_id: id,
      start_date: `${formatStartDatePOP} 00:00:00`,
      end_date: endDateTime,
      aggregate: Number(aggPOP),
    };
    if (smartTagPOPTime) {
      param["start_date"] = `${formatStartDatePOP} ${formatStartTimePOP}`;
      param["end_date"] = `${formatEndDatePOP} ${formatEndTimePOP}`;
    }
    try {
      const resp = await getPiechartCOC(param);
      if (resp.status == 200 || resp.status == 201) {
        setPiechartDataPOP(resp.data.payload);
      }
    } catch (error) {
      setPiechartDataPOP([]);

      console.log("handlesubmit", error);
    }
  };
  useEffect(() => {
    if (params.deviceId) {
      const findSelectedTag = selectPOPTagData.length
        ? selectPOPTagData
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.tagId)
        : [];

      if (
        disableOtherUnitsPOP &&
        findSelectedTag.length &&
        formatStartDatePOP &&
        formatEndDatePOP &&
        rangePOP != "none" &&
        rangeModalPOP == false &&
        activeSPCClass == "reports"
      ) {
        getPiechartPOPData(
          findSelectedTag,
          formatStartDatePOP,
          formatEndDatePOP,
          rangePOP,
          setPopBarGraphData1,
          smartTagPOPTime,
          formatStartTimePOP,
          formatEndTimePOP
        );
      } else {
        setPiechartDataPOP([]);
      }
    } else {
      const findSelectedTag = smartTagPOPSelectTag.length
        ? smartTagPOPSelectTag
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.tagId)
        : [];

      if (
        disableOtherUnitsPOP &&
        findSelectedTag.length &&
        formatStartDatePOP &&
        formatEndDatePOP &&
        rangePOP != "none" &&
        rangeModalPOP == false &&
        activeSPCClass == "reports"
      ) {
        getPiechartPOPData(
          findSelectedTag,
          formatStartDatePOP,
          formatEndDatePOP,
          rangePOP,
          setPopBarGraphData1,
          smartTagPOPTime,
          formatStartTimePOP,
          formatEndTimePOP
        );
      } else {
        setPopBarGraphData1([]);
      }
    }
  }, [
    disableOtherUnitsPOP,
    smartTagPOPSelectTag,
    formatStartDatePOP,
    formatEndDatePOP,
    rangeModalPOP,
    activeSPCClass,
    smartTagPOPTime,
    formatStartTimePOP,
    formatEndTimePOP,
    selectPOPTagData,
    aggPOP,
  ]);
  const getPiechartPOP1Data = async (id) => {
    let endDateTime = `${formatEndDatePOP1} 23:59:59`;
    if (!smartTagPOPTime) {
      // Time switch is OFF: check if end date is today
      const endDateObj = dayjs(formatEndDatePOP1);
      const today = dayjs();
      const isToday =
        endDateObj.format("YYYY-MM-DD") === today.format("YYYY-MM-DD");
      if (isToday) {
        // End date is today: use current time
        endDateTime = today.format("YYYY-MM-DD HH:mm:ss");
      }
    }

    const param = {
      company: params.companyid,
      plant: params.plantid,
      tag_id: id,
      start_date: `${formatStartDatePOP1} 00:00:00`,
      end_date: endDateTime,
      aggregate: Number(aggPOP),
    };
    if (smartTagPOPTime) {
      param["start_date"] = `${formatStartDatePOP1} ${formatStartTimePOP1}`;
      param["end_date"] = `${formatEndDatePOP1} ${formatEndTimePOP1}`;
    }
    try {
      const resp = await getPiechartCOC(param);
      if (resp.status == 200 || resp.status == 201) {
        setPiechartDataPOP1(resp.data.payload);
      }
    } catch (error) {
      setPiechartDataPOP1([]);

      console.log("handlesubmit", error);
    }
  };

  useEffect(() => {
    if (params.deviceId) {
      const findSelectedTag = selectPOPTagData.length
        ? selectPOPTagData
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.tagId)
        : [];

      if (
        disableOtherUnitsPOP &&
        findSelectedTag.length &&
        formatStartDatePOP1 &&
        formatEndDatePOP1 &&
        activeSPCClass == "reports"
      ) {
        getPiechartPOP1Data(
          findSelectedTag,
          formatStartDatePOP1,
          formatEndDatePOP1,
          rangePOP,
          setPopBarGraphData2,
          smartTagPOPTime,
          formatStartTimePOP1,
          formatEndTimePOP1
        );
      } else {
        setPiechartDataPOP1([]);
      }
    }
    const findSelectedTag = smartTagPOPSelectTag.length
      ? smartTagPOPSelectTag
        .filter((f) => f.plantId === params.plantid)
        .map((row) => row.tagId)
      : [];

    if (
      disableOtherUnitsPOP &&
      findSelectedTag.length &&
      formatStartDatePOP1 &&
      formatEndDatePOP1 &&
      rangeModalPOP == false &&
      activeSPCClass == "reports"
    ) {
      getPiechartPOP1Data(
        findSelectedTag,
        formatStartDatePOP1,
        formatEndDatePOP1,
        rangePOP,
        setPopBarGraphData2,
        smartTagPOPTime,
        formatStartTimePOP1,
        formatEndTimePOP1
      );
    } else {
      setPiechartDataPOP1([]);
    }
  }, [
    disableOtherUnitsPOP,
    smartTagPOPSelectTag,
    formatStartDatePOP1,
    formatEndDatePOP1,
    rangePOP,
    activeSPCClass,
    smartTagPOPTime,
    formatStartTimePOP1,
    formatEndTimePOP1,
    selectPOPTagData,
    aggPOP,
  ]);
  useEffect(() => {
    if (params.deviceId) {
      const findSelectedTag = selectPOPTagData.length
        ? selectPOPTagData
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.tagId)
        : [];

      if (
        !disableOtherUnitsPOP &&
        findSelectedTag.length &&
        formatStartDatePOP &&
        formatEndDatePOP &&
        rangePOP != "none" &&
        rangeModalPOP == false &&
        activeSPCClass == "reports"
      ) {
        setPopBarGraphData1([]);
      } else {
        setPopBarGraphData1([]);
      }
    } else {
      const findSelectedTag = smartTagPOPSelectTag.length
        ? smartTagPOPSelectTag
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.tagId)
        : [];

      if (
        !disableOtherUnitsPOP &&
        findSelectedTag.length &&
        formatStartDatePOP &&
        formatEndDatePOP &&
        rangePOP != "none" &&
        rangeModalPOP == false &&
        activeSPCClass == "reports"
      ) {
        setPopBarGraphData1([]);
      } else {
        setPopBarGraphData1([]);
      }
    }
  }, [
    smartTagPOPSelectTag,
    formatStartDatePOP,
    formatEndDatePOP,
    rangeModalPOP,
    activeSPCClass,
    smartTagPOPTime,
    formatStartTimePOP,
    formatEndTimePOP,
    selectPOPTagData,
    !disableOtherUnitsPOP,
  ]);

  const getReportAnalyticsChatAPIPOP = async (
    tagId,
    startDate,
    endDate,
    rangValuePOP,
    setState,
    smartTagPOPTime,
    startTime,
    endTime
  ) => {
    let endDateTime = `${formatEndDatePOP} 23:59:59`;
    if (!smartTagPOPTime) {
      // Time switch is OFF: check if end date is today
      const endDateObj = dayjs(formatEndDatePOP);
      const today = dayjs();
      const isToday =
        endDateObj.format("YYYY-MM-DD") === today.format("YYYY-MM-DD");
      if (isToday) {
        // End date is today: use current time
        endDateTime = today.format("YYYY-MM-DD HH:mm:ss");
      }
    }

    const paramReq = {
      company: params.companyid,
      plant: params.plantid,
      tag_id: tagId,
      aggregate: Number(aggPOP),
      start_date: `${formatStartDatePOP} 00:00:00`,
      end_date: endDateTime,
    };

    if (smartTagPOPTime) {
      paramReq["start_date"] = `${formatStartDatePOP} ${formatStartTimePOP}`;
      paramReq["end_date"] = `${formatEndDatePOP} ${formatEndTimePOP}`;
    }
    try {
      getReportAPIAnalyticsData(paramReq, setState, setShimmerPOP);
    } catch (error) {
      // Error handling
    }
  };

  useEffect(() => {
    if (params.deviceId) {
      const findSelectedTag = selectPOPTagData.length
        ? selectPOPTagData
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.tagId)
        : [];

      if (
        disableOtherUnitsPOP &&
        findSelectedTag.length &&
        formatStartDatePOP &&
        formatEndDatePOP &&
        rangePOP != "none" &&
        rangeModalPOP == false &&
        activeSPCClass == "reports"
      ) {
        getReportAnalyticsChatAPIPOP(
          findSelectedTag,
          formatStartDatePOP,
          formatEndDatePOP,
          rangePOP,
          setPopBarGraphData1,
          smartTagPOPTime,
          formatStartTimePOP,
          formatEndTimePOP
        );
      } else {
        setPopBarGraphData1([]);
      }
    } else {
      const findSelectedTag = smartTagPOPSelectTag.length
        ? smartTagPOPSelectTag
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.tagId)
        : [];

      if (
        disableOtherUnitsPOP &&
        findSelectedTag.length &&
        formatStartDatePOP &&
        formatEndDatePOP &&
        rangePOP != "none" &&
        rangeModalPOP == false &&
        activeSPCClass == "reports"
      ) {
        getReportAnalyticsChatAPIPOP(
          findSelectedTag,
          formatStartDatePOP,
          formatEndDatePOP,
          rangePOP,
          setPopBarGraphData1,
          smartTagPOPTime,
          formatStartTimePOP,
          formatEndTimePOP
        );
      } else {
        setPopBarGraphData1([]);
      }
    }
  }, [
    disableOtherUnitsPOP,
    smartTagPOPSelectTag,
    formatStartDatePOP,
    formatEndDatePOP,
    rangeModalPOP,
    activeSPCClass,
    smartTagPOPTime,
    formatStartTimePOP,
    formatEndTimePOP,
    selectPOPTagData,
    aggPOP,
  ]);

  const getReportAnalyticsChatAPIPOP1 = async (
    tagId,
    startDate,
    endDate,
    rangValuePOP,
    setState,
    smartTagPOPTime,
    startTime,
    endTime
  ) => {
    let endDateTime = `${formatEndDatePOP1} 23:59:59`;
    if (!smartTagPOPTime) {
      // Time switch is OFF: check if end date is today
      const endDateObj = dayjs(formatEndDatePOP1);
      const today = dayjs();
      const isToday =
        endDateObj.format("YYYY-MM-DD") === today.format("YYYY-MM-DD");
      if (isToday) {
        // End date is today: use current time
        endDateTime = today.format("YYYY-MM-DD HH:mm:ss");
      }
    }

    const paramReq = {
      company: params.companyid,
      plant: params.plantid,
      tag_id: tagId,
      aggregate: Number(aggPOP),
      start_date: `${formatStartDatePOP1} 00:00:00`,
      end_date: endDateTime,
    };

    if (smartTagPOPTime) {
      paramReq["start_date"] = `${formatStartDatePOP1} ${formatStartTimePOP1}`;
      paramReq["end_date"] = `${formatEndDatePOP1} ${formatEndTimePOP1}`;
    }
    try {
      getReportAPIAnalyticsData(paramReq, setState, setShimmerPOP);
    } catch (error) {
      // Error handling
    }
  };
  useEffect(() => {
    if (params.deviceId) {
      const findSelectedTag = selectPOPTagData.length
        ? selectPOPTagData
          .filter((f) => f.plantId === params.plantid)
          .map((row) => row.tagId)
        : [];

      if (
        disableOtherUnitsPOP &&
        findSelectedTag.length &&
        formatStartDatePOP1 &&
        formatEndDatePOP1 &&
        activeSPCClass == "reports"
      ) {
        getReportAnalyticsChatAPIPOP1(
          findSelectedTag,
          formatStartDatePOP1,
          formatEndDatePOP1,
          rangePOP,
          setPopBarGraphData2,
          smartTagPOPTime,
          formatStartTimePOP1,
          formatEndTimePOP1
        );
      } else {
        setPopBarGraphData2([]);
      }
    }
    const findSelectedTag = smartTagPOPSelectTag.length
      ? smartTagPOPSelectTag
        .filter((f) => f.plantId === params.plantid)
        .map((row) => row.tagId)
      : [];

    if (
      disableOtherUnitsPOP &&
      findSelectedTag.length &&
      formatStartDatePOP1 &&
      formatEndDatePOP1 &&
      rangeModalPOP == false &&
      activeSPCClass == "reports"
    ) {
      getReportAnalyticsChatAPIPOP1(
        findSelectedTag,
        formatStartDatePOP1,
        formatEndDatePOP1,
        rangePOP,
        setPopBarGraphData2,
        smartTagPOPTime,
        formatStartTimePOP1,
        formatEndTimePOP1
      );
    } else {
      setPopBarGraphData2([]);
    }
  }, [
    disableOtherUnitsPOP,
    smartTagPOPSelectTag,
    formatStartDatePOP1,
    formatEndDatePOP1,
    rangePOP,
    activeSPCClass,
    smartTagPOPTime,
    formatStartTimePOP1,
    formatEndTimePOP1,
    selectPOPTagData,
    aggPOP,
  ]);

  // useEffect(() => {
  //   if (params.deviceId) {
  //     const findSelectedTag = selectPOPTagData.length
  //       ? selectPOPTagData
  //           .filter((f) => f.plantId === params.plantid)
  //           .map((row) => row.tagId)
  //       : [];

  //     if (
  //       !disableOtherUnitsPOP &&
  //       findSelectedTag.length &&
  //       formatStartDatePOP1 &&
  //       formatEndDatePOP1 &&
  //       rangePOP != "none" &&
  //       activeSPCClass == "reports"
  //     ) {
  //       setPopBarGraphData2([]);
  //     } else {
  //       setPopBarGraphData2([]);
  //     }
  //   }
  //   const findSelectedTag = smartTagPOPSelectTag.length
  //     ? smartTagPOPSelectTag
  //         .filter((f) => f.plantId === params.plantid)
  //         .map((row) => row.tagId)
  //     : [];

  //   if (
  //     !disableOtherUnitsPOP &&
  //     findSelectedTag.length &&
  //     formatStartDatePOP1 &&
  //     formatEndDatePOP1 &&
  //     rangePOP != "none" &&
  //     rangeModalPOP == false &&
  //     activeSPCClass == "reports"
  //   ) {
  //     setPopBarGraphData2([]);
  //   } else {
  //     setPopBarGraphData2([]);
  //   }
  // }, [
  //   smartTagPOPSelectTag,
  //   formatStartDatePOP1,
  //   formatEndDatePOP1,
  //   rangePOP,
  //   activeSPCClass,
  //   smartTagPOPTime,
  //   formatStartTimePOP1,
  //   formatEndTimePOP1,
  //   selectPOPTagData,
  // ]);

  const handleGetUnitsData = async (id) => {
    const params = {
      device: id,
    };
    try {
      const resp = await getDeviceUnits(params);
      if (resp.status == 200 || resp.status == 201) {
        setUnitsData(resp.data.payload);
        const requiredUnits = ["kvah", "kvarh", "kwh", "agg"];
        const hasRequiredUnit = resp.data.payload?.some((unit) =>
          requiredUnits.includes(unit.toLowerCase())
        );

        // Disable other units if one of the required units is found
        setDisableOtherUnits(hasRequiredUnit);
      }
    } catch (error) {
      // Error handling
    }
  };
  return (
    <>
      <div className="page-wraper">
        <div className="page-header page-header-analytics">
          <div
            className="page-back-btn"
            onClick={() => {
              dispatch(
                setSmartTagReportData({
                  activeSPCClass: "",
                  SPCTopBarTagData: {},
                  SPCtagUnit: "",
                  SPCtagClickebleData: [],
                })
              );
              navigate(
                `/smarttag-spc-dashboard/company/${params.companyid}/plant/${params.plantid}`
              );
            }}
          >
            <ArrowBackIcon />
            <span>SPC</span>
          </div>
        </div>

        <>
          <div className="analysis-tabs-btn pt-3">
            <div className="analytics-tabs-btn">
              <div className="d-flex">
                {/* <button
                  className={`${activeSPCClass == "analytics"
                      ? "Analytics-tabs-overview"
                      : "Reports-tabs-overview"
                    }`}
                  onClick={() =>
                    dispatch(
                      setSmartTagReportData({
                        activeSPCClass: "analytics",
                      })
                    )
                  }
                  style={{ width: "210px", height: "50px" }}
                >
                  Analytics
                </button>
                <button
                  className={`${activeSPCClass == "reports"
                      ? "Analytics-tabs-overview"
                      : "Reports-tabs-overview"
                    }`}
                  onClick={() =>
                    dispatch(
                      setSmartTagReportData({ activeSPCClass: "reports" })
                    )
                  }
                  style={{ width: "210px", height: "50px" }}
                >
                  Reports
                </button> */}
              </div>
            </div>
            {activeSPCClass == "analytics" ? (
              <>
                <div
                  className="analytics-aggregation analytics-datepicker "
                  style={{ justifyContent: "flex-end" }}
                >
                  <FormGroup aria-label="position" row>
                    <FormControlLabel
                      value="top"
                      control={
                        <Switch color="primary" checked={smartTagCOCTime} />
                      }
                      label="Time"
                      labelPlacement="top"
                      onChange={handleToggleTime}
                    />
                  </FormGroup>

                  <COCVmsDatePicker
                    time={smartTagCOCTime}
                    startDateReFormat={startDateReFormat}
                    endDateReFormat={endDateReFormat}
                    handleStartDate={handleStartDate}
                    handleEndDate={handleEndDate}
                  />
                </div>
              </>
            ) : (
              <>
                <div
                  className="analytics-aggregation analytics-datepicker analyticsAgg-datePicker gap-2"
                  style={{ marginTop: 0 }}
                >
                  <select
                    className="form-input-class"
                    style={{
                      padding: "10px 8px",
                      borderRadius: "4px",
                      width: "150px",
                      backgroundColor: "white",
                      border: "1px solid #ccc",
                      fontSize: "14px",
                      fontWeight: "500",
                      marginRight: "8px",
                    }}
                    value={selectedChartType}
                    onChange={(e) => setSelectedChartType(e.target.value)}
                  >
                    <option value="I Chart">I Chart</option>
                    <option value="MR Chart">MR Chart</option>
                  </select>
                  <div className="d-flex align-items-center gap-2">
                    <h6 className="mb-0">Interval</h6>
                    <Box sx={{ minWidth: 200 }} style={{ float: "right" }}>
                      <select
                        className="form-input-class"
                        style={{ padding: "10px 8px", borderRadius: "4px" }}
                        value={selectedReportChartInterval}
                        onChange={(e) => {
                          setSelectedReportChartInterval(e.target.value);
                          // Update POPIntervalTimePop to trigger API call
                          dispatch(
                            setSmartTagReportData({
                              POPIntervalTimePop: e.target.value,
                            })
                          );
                        }}
                      >
                        {/* <option value="1">1 Min</option> */}
                        <option value="5">5 Min</option>
                        <option value="10">10 Min</option>
                        <option value="15">15 Min</option>
                      </select>
                    </Box>
                  </div>
                  <div className="timeToggle">
                    <h6 style={{ marginBottom: "0px" }}>Time</h6>
                    <FormGroup aria-label="position" row>
                      <FormControlLabel
                        value="top"
                        control={
                          <Switch color="primary" checked={smartTagPOPTime} />
                        }
                        // label="Time"
                        labelPlacement="top"
                        onChange={handlePOPToggleTime}
                        style={{ margin: "0px" }}
                      />
                    </FormGroup>
                  </div>

                  {/* <div className="d-flex gap-2"> */}
                  <COCVmsDatePicker
                    isSPC={true}
                    time={smartTagPOPTime}
                    startDateReFormat={startDateRePOPFormat}
                    endDateReFormat={endDateRePOPFormat}
                    handleStartDate={handlePOPStartDate}
                    handleEndDate={handlePOPEndDate}
                  />
                  {/* </div> */}
                </div>
              </>
            )}
          </div>
        </>
        <div className="pt-2 consumption-grid-card">
          {activeSPCClass == "analytics" ? (
            <SPCSmartTagList
              activeSPCClass={activeSPCClass}
              time={smartTagCOCTime}
              formatStartDate={formatStartDate}
              formatEndDate={formatEndDate}
              formatStartTime={formatStartTime}
              formatEndTime={formatEndTime}
              range={rangeCOC}
              machines={Machines}
              units={unitsData}
              handleSelectMachine={handleSelectMachine}
              handleSelectTagUnit={handleSelectReportsTagUnit}
              handleSelectTag={handleSelectReportTag}
              tagListData={tagListData}
              isShimmerdevicelist={isShimmerdevicelistCOC}
              isShimmerUnitlist={isShimmerUnitlistCOC}
              isShimmerMachineslist={isShimmerMachineslistCOC}
              smartTagSelectmachine={
                params.deviceId
                  ? selectDeviceData
                  : smartTagCOCSelectMachine.length
                    ? smartTagCOCSelectMachine.filter(
                      (f) => f.plantId === params.plantid
                    )
                    : []
              }
              smartTagSelectTagUnit={
                params.deviceId
                  ? selectUnitData
                  : smartTagCOCSelectUnit.length
                    ? smartTagCOCSelectUnit.filter(
                      (f) => f.plantId === params.plantid
                    )
                    : []
              }
              snartTagSelectTag={
                params.deviceId
                  ? selectTagData
                  : smartTagCOCSelectTag.length
                    ? smartTagCOCSelectTag.filter(
                      (f) => f.plantId === params.plantid
                    )
                    : []
              }
              SmartTagSelectSwitch={smartTagCOCSwitch}
              handleToggleTime={() => setSmartTagCOCSwitch(!smartTagCOCSwitch)}
              activeTabClass={activeSPCClass}
              disableOtherUnits={disableOtherUnits}
              interval={
                smartTagCOCSwitch ? LineCOCIntervalTime : COCIntervalTime
              }
              agg={Number(aggCOC)}
              getAnalyticsChartsBase64={getAnalyticsChartsBase64}
            />
          ) : (
            <SPCSmartTagList
              activeSPCClass={activeSPCClass}
              time={smartTagPOPTime}
              formatStartDate={formatStartDatePOP}
              formatEndDate={formatEndDatePOP}
              formatStartTime={formatStartTimePOP}
              formatEndTime={formatEndTimePOP}
              range={rangePOP}
              machines={Machines}
              units={unitsData}
              handleSelectMachine={handlePOPSelectMachine}
              handleSelectTagUnit={handlePOPSelectTagUnit}
              handleSelectTag={handlePOPSelectTag}
              tagListData={tagListData1}
              isShimmerdevicelist={isShimmerdevicelistPOP}
              isShimmerUnitlist={isShimmerUnitlistPOP}
              isShimmerMachineslist={isShimmerMachineslistPOP}
              smartTagSelectmachine={
                params.deviceId
                  ? selectPOPDeviceData
                  : smartTagPOPSelectMachine.length
                    ? smartTagPOPSelectMachine.filter(
                      (f) => f.plantId === params.plantid
                    )
                    : []
              }
              smartTagSelectTagUnit={
                params.deviceId
                  ? selectPOPUnitData
                  : smartTagPOPSelectUnit.length
                    ? smartTagPOPSelectUnit.filter(
                      (f) => f.plantId === params.plantid
                    )
                    : []
              }
              snartTagSelectTag={
                params.deviceId
                  ? selectPOPTagData
                  : smartTagPOPSelectTag.length
                    ? smartTagPOPSelectTag.filter(
                      (f) => f.plantId === params.plantid
                    )
                    : []
              }
              selectPOPUnitData={selectPOPUnitData}
              formatStartDatePOP1={formatStartDatePOP1}
              formatEndDatePOP1={formatEndDatePOP1}
              formatStartTimePOP1={formatStartTimePOP1}
              formatEndTimePOP1={formatEndTimePOP1}
              SmartTagSelectSwitch={smartTagPOPSwitch}
              handleToggleTime={
                () => setSmartTagPOPSwitch(!smartTagPOPSwitch)
                // dispatch(
                //   setSmartTagReportData({
                //     smartTagPOPSwitch: !smartTagPOPSwitch,
                //   })
                // )
              }
              activeTabClass={activeSPCClass}
              disableOtherUnits={disableOtherUnitsPOP}
              interval={
                smartTagPOPSwitch ? LinePOPIntervalTime : POPIntervalTimePop
              }
              agg={Number(aggPOP)}
              getChartBase64={getChartBase64}
              selectedChartType={selectedChartType}
            />
          )}

          <SPCGraphComponent
            SPC={true}
            activeTabClass={activeSPCClass}
            Graphdata={[]}
            LineGraphData={[]}
            spcUcl={null}
            spcCl={null}
            spcLcl={null}
            spcTagUnit=""
            COCIntervalTime={COCIntervalTime}
            POPIntervalTimePop={POPIntervalTimePop}
            tagID={
              params.deviceId
                ? selectTagData
                : smartTagCOCSelectTag.length
                  ? smartTagCOCSelectTag.filter(
                    (f) => f.plantId === params.plantid
                  )
                  : []
            }
            tagSelectPOP={
              smartTagPOPSelectTag.length
                ? smartTagPOPSelectTag.filter(
                  (f) => f.plantId === params.plantid
                )
                : []
            }
            averageArray={averageCOCLineArray}
            averagePOP={averagePOPLineArray}
            BarGraphData1={popBarGraphData1}
            BarGraphData2={popBarGraphData2}
            VmsReportSelectmachine={
              smartTagPOPSelectMachine.length
                ? smartTagPOPSelectMachine.filter(
                  (f) => f.plantId === params.plantid
                )
                : []
            }
            VmsReportSelectmachine1={
              smartTagCOCSelectMachine.length
                ? smartTagCOCSelectMachine.filter(
                  (f) => f.plantId === params.plantid
                )
                : []
            }
            LineChartdata={[]}
            LineChartdata2={[]}
            isShimmerCOC={isShimmerCOC}
            isShimmerPOP={isShimmerPOP}
            isShimmerLineChartPOP={false}
            isShimmerLineChartCOC={false}
            setLineCOCIntervalTime={setLineCOCIntervalTime}
            setLinePOPIntervalTime={setLinePOPIntervalTime}
            LineCOCIntervalTime={LineCOCIntervalTime}
            LinePOPIntervalTime={LinePOPIntervalTime}
            smartTagCOCSwitch={smartTagCOCSwitch}
            smartTagPOPSwitch={smartTagPOPSwitch}
            disableOtherUnits={disableOtherUnits}
            disableOtherUnitsPOP={disableOtherUnitsPOP}
            piechartData={piechartData}
            pieChartSum={pieChartSum}
            piechartDataPOP={piechartDataPOP}
            piechartDataPOP1={piechartDataPOP1}
            aggCOC={disableOtherUnits}
            aggPOP={disableOtherUnitsPOP}
            // Analytics I Chart and MR Chart data
            analyticsIChartData={analyticsIChartData}
            analyticsMRChartData={analyticsMRChartData}
            analyticsIChartUcl={analyticsIChartUcl}
            analyticsIChartCl={analyticsIChartCl}
            analyticsIChartLcl={analyticsIChartLcl}
            analyticsMRChartUcl={analyticsMRChartUcl}
            analyticsMRChartCl={analyticsMRChartCl}
            analyticsMRChartLcl={analyticsMRChartLcl}
            analyticsTagName={analyticsTagName}
            analyticsTagColor={analyticsTagColor}
            // Separate intervals for I Chart and MR Chart
            analyticsIChartInterval={analyticsIChartInterval}
            analyticsMRChartInterval={analyticsMRChartInterval}
            setAnalyticsIChartInterval={setAnalyticsIChartInterval}
            setAnalyticsMRChartInterval={setAnalyticsMRChartInterval}
            // Reports mode props
            formatStartDatePOP={formatStartDatePOP}
            formatEndDatePOP={formatEndDatePOP}
            formatStartTimePOP={formatStartTimePOP}
            formatEndTimePOP={formatEndTimePOP}
            smartTagPOPTime={smartTagPOPTime}
            rangePOP={rangePOP}
            params={params}
            selectedReportChartInterval={selectedReportChartInterval}
            selectedChartType={selectedChartType}
            onDropdownTagChange={handleStoreSeletedDataPOPFromDropdown}
            storedLeftTagUnit={selectedPreviousData?.left_tag_unit}
            storedRightTagUnit={selectedPreviousData?.right_tag_unit}
            onChartRefReady={(ref) => {
              reportsChartRef.current = ref;
            }}
            onAnalyticsIChartRefReady={(ref) => {
              analyticsIChartRef.current = ref;
            }}
            onAnalyticsMRChartRefReady={(ref) => {
              analyticsMRChartRef.current = ref;
            }}
          />
        </div>
      </div>
    </>
  );
};
export default SPCMachineAnalytics;